import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import Select, { components } from "react-select";
import "../../app/styles/components/ui/Html.css";
import { iconPaths } from "../../shared/constants/iconPaths";
import { SvgIcon } from "./Svg";
import ShowContentModal from "./Modals";
import { DateRange } from "react-date-range";
import { isSameDay } from "date-fns";
import "react-date-range/dist/styles.css"; // Import the styles
import "react-date-range/dist/theme/default.css"; // Import the theme
import { Switch, Tooltip, Dropdown, Menu, Button } from "antd";

// import PDFDocument from 'pdfkit';
// import blob-stream from 'blob-stream';
import { DownOutlined } from "@ant-design/icons";
import {
  fieldContainsValue,
  textBeautifyFunction,
  capitalizeFirstLetterOfWord,
  capitalizeFirstLetterEachWord,
  uppercaseFirstChar,
  DateFormatter,
  convertToISTFormatted,
  parseAndJoinStringArray,
  getDataType,
  removeEmptyValuesFromObject,
} from "../../controllers/common";
import { useSelector, useDispatch } from "react-redux";
import { setDocumentModalValue, clearDocumentModalValue } from "../../slices/driverCommon";
import { Link, useLocation } from "react-router-dom";
import { DocumentUploadHandler } from "./camera/Camera";
import classNames from "classnames";
import { FigmaSvgIcon } from "./FigmaSvgIcon";
import { Input } from "antd";
import { logout } from "../../slices/authSlice";
import { useNavigate } from "react-router-dom";
// import Input from "../common/Input";
import { Modal, Typography, notification } from "antd";
import { getAllHubsListAPI } from "../../api/hub";
import ToggleSwitch from "./form/ToggleSwitch";
import { takeReadAbelError } from "../../controllers/readAbleError";

import { Eye } from "lucide-react";
/** @deprecated  */
export const HtmlSelect = ({ children, style = {}, ...props }) => {
  return (
    <select
      style={style}
      id="custom-html-select"
      {...props}
      className=" border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
    >
      {children}
    </select>
  );
};
/** @deprecated  */
export const ReactSelect = ({
  placeholder,
  options = [],
  notFoundMessage,
  onChange = () => {},
  value,
  disabled,
  isClearable = true,
  optionStyle = {},
  isMulti = false,
  needOptionLarge = false,
  hideClearIndicator = false,
  borderRadius = "6px",
  hideDropdownIndicator = false,
  isError = false,
}) => {
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    if (value || value === 0 || value === "0") {
      setSelectedOption(options?.find((option) => option?.value === value) || null);
    } else {
      setSelectedOption(null);
    }
  }, [value, options]);

  const handleChange = (selected) => {
    setSelectedOption(selected);
    onChange(selected);
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: isError ? "#ff4d4f" : "#dfdfdf",
      boxShadow: "none",
      "&:hover": {
        borderColor: isError ? "#ff4d4f" : "#4B465C",
      },
      borderRadius: borderRadius,
      paddingTop: "0px",
      paddingBottom: "0px",
      height: "38px",
      display: "flex",
      alignItems: "center",
      cursor: state.isDisabled ? "not-allowed" : "pointer",
      paddingLeft: "2.8px",
      backgroundColor: state.isDisabled ? "white" : "white",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "6px",
      marginTop: "5px",
      zIndex: 1,
      ...(needOptionLarge && { width: needOptionLarge ? "max-content" : "" }),
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#f0f0f0" : "#fff",
      color: state.isDisabled ? "#aaaaaa" : "#4B465C",
      padding: "8px",
      cursor: state.isDisabled ? "not-allowed" : "pointer",
      "&:hover": {
        backgroundColor: state.isDisabled ? "#fff" : "#e0e0e0",
      },
      fontSize: "15px",
      opacity: state.isDisabled ? 0.5 : 0.8,
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      ...optionStyle,
    }),

    singleValue: (provided) => ({
      ...provided,
      color: "#4B465C",
      // color: `${selectedOption?"#4B465C":"#aaaaaa"}`,
      fontSize: "15px",
      fontFamily: "'DM Sans', sans-serif",
      fontWeight: 400,
      lineHeight: "24px",
      letterSpacing: "0px",
      verticalAlign: "middle",
      margin: "0",
      // opacity: 0.9,
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#aaaaaa",
      fontSize: "15px",
      fontFamily: "'DM Sans', sans-serif",
      fontWeight: 400,
      lineHeight: "24px",
      letterSpacing: "0px",
      verticalAlign: "middle",
      margin: "0",
      // opacity: 0.8,
    }),
    input: (provided) => ({
      ...provided,
      color: "#4B465C",
      fontSize: "15px",
      lineHeight: "24px",
      margin: "0",
      opacity: 0.8,
    }),
    noOptionsMessage: (provided) => ({
      ...provided,
      color: "#4B465C",
      padding: "8px",
      textAlign: "center",
      fontSize: "15px",
      opacity: 0.8,
    }),
    clearIndicator: (provided) => ({
      ...provided,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 1000,
    }),
  };

  const CustomClearIndicator = (props) => {
    return (
      <components.ClearIndicator {...props}>
        <span
          className="-ml-[16px] z-50"
          style={{
            fontSize: "13px",
            cursor: "pointer",
            color: "#333",
          }}
        >
          ✖
        </span>
      </components.ClearIndicator>
    );
  };
  const CustomDropdownIndicator = (props) => {
    const { selectProps } = props;

    // If clearable and value is selected and clear indicator is not hidden, don't show dropdown icon
    if (selectProps?.isClearable && selectProps?.value && !hideClearIndicator) {
      return null;
    }

    return (
      <components.DropdownIndicator {...props}>
        <FigmaSvgIcon type="dropdown-icon" />
      </components.DropdownIndicator>
    );
  };

  const noOptionsMessage = () => (
    <div style={{ color: "#999", textAlign: "center" }}>
      {notFoundMessage ? notFoundMessage : "No options"}
    </div>
  );
  return (
    <Select
      isDisabled={disabled}
      styles={customStyles}
      value={selectedOption}
      onChange={handleChange}
      options={[...options]}
      placeholder={`Select ${placeholder ? placeholder : ""}`}
      isClearable={isClearable}
      noOptionsMessage={noOptionsMessage}
      isOptionDisabled={(option) => option.disabled === true}
      components={{
        ClearIndicator: hideClearIndicator ? () => null : CustomClearIndicator,
        DropdownIndicator: hideDropdownIndicator ? () => null : CustomDropdownIndicator,
        IndicatorSeparator: () => null,
      }}
      menuPortalTarget={document.body}
      className={`input-value-dm-400 `}
      isMulti={isMulti}
    />
  );
};
/** @deprecated  */
export const HtmlButton = ({
  className,
  style,
  loading = false,
  loadingPosition = "right",
  svgType,
  svgSize,
  svgColor,
  svgPosition = "left",
  text,
  iconPosition = "left",
  iconType,
  icon = false,
  type,
  disabled = false,
  disabledMessage = "",
  iconSize = "20px",
  outline = false,
  onClick = () => {},
  confirmation = false,
  confirmationText = "Are You Sure",
  confirmationType = "confirmation",
  beforeConfirm = () => {},
  tollTip,
  tooltip,
  loadingText = "Please wait",
}) => {
  const [confirmationState, setConfirmationState] = useState(0);
  const [confirmationValue, setConfirmationValue] = useState(text);
  const [buttonClass, setButtonClass] = useState(["htm-button"]);
  const [showTooltip, setShowTooltip] = useState(false);
  useEffect(() => {
    if (disabled) {
      setButtonClass([
        // "cursor-not-allowed",
        "html-disabled-button",
        "html-button",
        `html-${type}-button-disabled`,
      ]);
    } else if (type && outline && !disabled && confirmationState === 0) {
      setButtonClass([
        `html-${type}-button-outline`,
        "html-button",
        // "cursor-pointer",
      ]);
    } else if (type && !outline && !disabled && confirmationState === 0) {
      setButtonClass([`html-${type}-button`, "html-button", "cursor-pointer"]);
    } else if (type && !outline && !disabled && confirmationState > 0) {
      setButtonClass([
        `html-${confirmationType}-button`,
        "html-button",
        // "cursor-pointer",
      ]);
    } else if (type && outline && !disabled && confirmationState > 0) {
      setButtonClass([
        `html-${confirmationType}-button-outline`,
        "html-button",
        // "cursor-pointer",
      ]);
    }
  }, [disabled, type, outline, confirmationState, confirmationType]);
  return (
    <div
      title={tollTip || tooltip}
      className="relative"
      onMouseEnter={() => {
        if (disabled && disabledMessage) {
          setShowTooltip(true);
        }
      }}
      onMouseLeave={() => {
        setShowTooltip(false);
      }}
    >
      <button
        style={{
          paddingLeft: icon && iconPosition === "left" ? "8px" : "",
          paddingRight: icon && iconPosition === "right" ? "8px" : "",
          ...style,
          cursor: disabled ? "not-allowed" : "pointer",
        }}
        onClick={(e) => {
          if (confirmation) {
            setConfirmationState(confirmationState + 1);
            setConfirmationValue(confirmationText);

            if (confirmationState > 0) {
              onClick(e);
              setConfirmationValue(text);
              setConfirmationState(0);
            } else if (confirmationState === 0) {
              beforeConfirm(e);
            }
          } else {
            onClick(e);
          }
        }}
        className={`${buttonClass?.join(" ")} ${className}`}
        disabled={disabled || loading}
      >
        {loading && loadingPosition === "left" && <SvgIcon type="spinner" />}
        {svgType && svgPosition === "left" && (
          <SvgIcon color={svgColor} size={svgSize} type={svgType} />
        )}
        {icon && iconType && iconPosition === "left" && (
          <img
            className="bg-red- custom-icon"
            width={iconSize}
            height={iconSize}
            src={iconPaths[iconType] ?? iconPaths.default}
            alt="icon"
          />
        )}
        {loading ? loadingText : confirmation ? confirmationValue : text}
        {icon && iconType && iconPosition === "right" && (
          <img
            width={iconSize}
            height={iconSize}
            src={iconPaths[iconType] ?? iconPaths.default}
            alt="icon"
            className="custom-icon"
          />
        )}
        {svgPosition === "right" && <SvgIcon color={svgColor} size={svgSize} type={svgType} />}
        {loading && loadingPosition === "right" && <SvgIcon type="spinner" />}
      </button>

      {/* Tooltip for disabled state */}
      <TooltipPopup
        show={showTooltip && disabled && disabledMessage}
        message={disabledMessage}
        position="top"
        maxWidth="200px"
      />
    </div>
  );
};
/** @deprecated  */
export const HtmlAlert = ({ message, description, type, onClose, showIcon }) => {
  // const [visible, setVisible] = useState(true);
  const handleClose = () => {
    if (onClose) onClose();
  };

  return (
    <div className={`html-alert html-alert-${type}`}>
      {showIcon && (
        <span className={`html-alert-icon html-icon-${type}`}>
          <SvgIcon size="10px" color="white" type={type} />
        </span>
      )}
      <div className="w-full pl-1">{message}</div>
      {description && <p>{description}</p>}
      {onClose && (
        <button onClick={handleClose} className="html-alert-close">
          X
        </button>
      )}
    </div>
  );
};
/** @deprecated  */
export const HtmlTableDocumentPreview = ({ value, text, download = false }) => {
  const [mImageUrl, setMImageUrl] = useState("");
  const [urls, setUrls] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [downloadImageUrl, setDownloadImageUrl] = useState("");
  const [numPages, setNumPages] = React.useState(null);
  const [pageNumber, setPageNumber] = React.useState(1);
  const [showModal, setShowModal] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  function isPdfUrl(url) {
    return url?.toLowerCase()?.endsWith(".pdf");
  }
  const normalizeImageUrl = (imageUrl) => {
    if (Array.isArray(imageUrl)) {
      return imageUrl;
    } else if (typeof imageUrl === "string") {
      try {
        const parsedArray = JSON.parse(imageUrl);
        if (Array.isArray(parsedArray)) {
          return parsedArray;
        }
      } catch (e) {
        return [imageUrl];
      }
    } else {
      return [];
    }
  };
  useEffect(() => {
    const normalUrls = normalizeImageUrl(value);
    setUrls(normalUrls);
    setDownloadImageUrl(normalUrls[0]);
  }, [value]);
  const handleLeftClick = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + urls.length) % urls.length);
    setDownloadImageUrl(urls[(currentIndex - 1 + urls.length) % urls.length]);
  };
  const handleRightClick = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % urls.length);
    setDownloadImageUrl(urls[(currentIndex + 1) % urls.length]);
  };
  const handleDownload = async () => {
    setDownloadLoading(true);
    try {
      const response = await fetch(downloadImageUrl);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = text ? text : "driver document";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("There was an error downloading the image:", error);
    }
    setDownloadLoading(false);
  };
  const clear = () => {
    setShowModal(false);
  };
  return (
    <div className="flex justify-center items-center">
      <ShowContentModal
        open={showModal}
        close={clear}
        title={text}
        // loading={ true}
        element={
          urls?.length > 0 && (
            <div className="flex relative h-auto flex-col m-auto items-center justify-center mb-0 pb-0 ">
              {!isPdfUrl(urls[currentIndex]) && (
                <img
                  src={urls[currentIndex]}
                  alt={text}
                  className="w-full h-auto object-cover rounded-md"
                />
              )}
              {isPdfUrl(urls[currentIndex]) && (
                <div
                  className="mr-12 ml-12"
                  style={{ width: "350px", height: "400px", overflow: "auto" }}
                >
                  <iframe
                    key={urls[currentIndex]}
                    src={urls[currentIndex]}
                    title="PDF Viewer"
                    width="100%"
                    height="100%"
                    style={{ border: "none", margin: "auto" }}
                  ></iframe>
                </div>
              )}
              {urls.length > 1 && (
                <div className="w-full flex justify-center items-center gap-2 mt-2">
                  <button
                    onClick={() => {
                      handleLeftClick();
                    }}
                  >
                    <SvgIcon size={25} type="left-arrow-point" />
                  </button>
                  <button
                    onClick={() => {
                      handleRightClick();
                    }}
                  >
                    <SvgIcon size={25} type="right-arrow-point" />
                  </button>
                </div>
              )}

              <div className={`flex justify-center mt-2 `}>
                {urls.length > 0 && download && (
                  <HtmlButton
                    loading={downloadLoading}
                    onClick={handleDownload}
                    type="primary"
                    text={`${downloadLoading ? "Please wait" : "Download"}`}
                  />
                )}
              </div>
            </div>
          )
        }
      />
      {(value && typeof value === "string" && value !== null) ||
      (Array?.isArray(value) && value?.length > 0) ? (
        <HtmlButton
          onClick={() => {
            setShowModal(true);
          }}
          svgType="upload-done"
          style={{ textDecoration: "underline", color: "green" }}
          text={text}
        />
      ) : (
        <HtmlButton svgType="upload" text="Upload Image" type={"primary"} outline={true} />
      )}
    </div>
  );
};
/** @deprecated  */
export const HtmlTextArea = ({
  disabled,
  allTimeEditMode,
  oneTimeEditMode,
  rows = 6,
  mandatory = false,
  required = false,
  placeholder,
  value,
  updatedValue,
  onChange = () => {},
  title,
  name,
  className,
  style,
}) => {
  const [access, setAccess] = useState(false);
  useEffect(() => {
    if (oneTimeEditMode) {
      setAccess(!fieldContainsValue(updatedValue));
    }
    if (allTimeEditMode) {
      setAccess(allTimeEditMode);
    }
    if (disabled) {
      setAccess(!disabled);
    }
  }, [oneTimeEditMode, disabled, value, updatedValue, allTimeEditMode]);
  return (
    <div>
      {title && (
        <h3 className="text-[13px] font-publicSans text-[#4B465C] mb-1 flex">
          {title} {mandatory && <SvgIcon size={10} type="star" />}
        </h3>
      )}
      <textarea
        name={name}
        rows={rows}
        cols={2}
        style={style}
        className={`${
          required ? "border-red-500" : ""
        } form-input p-2 w-full text-sm font-light text-gray-600 bg-transparent border border-gray-300 rounded-md focus:outline-none focus:ring-0 ${className}`}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={!access}
      ></textarea>
      {required && <p className="text-[13px] text-red-500">Required</p>}
    </div>
  );
};

//original htmlTable by Bashar
/** @deprecated  */
export const HtmlTable = ({
  columns = [],
  data = [],
  csvTitle = "data",
  margin = "auto",
  fileType = "pdf",
  csvDownloadFunction,
  csvDownload = false,
  className = "",
}) => {
  const getValueFromPath = (obj, path) => {
    if (Array.isArray(path)) {
      return path.reduce((acc, key) => acc && acc[key], obj);
    } else if (typeof path === "string") {
      return path.split(".").reduce((acc, key) => acc && acc[key], obj);
    }
    return undefined;
  };
  const downloadCSV = () => {
    const csvRows = [];
    const headers = columns
      .filter((item) => item.show)
      .map((column) => {
        csvRows.push(column.title);
      });
    data.forEach((row) => {
      const values = columns
        .filter((item) => item.show)
        .map((column) => {
          const value = getValueFromPath(row, column.dataIndex);
          return Array.isArray(value) ? value.join(", ") : value;
        });
      for (let index = 0; index < values.length; index++) {
        csvRows[index] = [csvRows[index], values[index]].join(",");
      }
    });
    const csvString = csvRows.join("\n");
    const blob = new Blob([csvString], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.setAttribute("href", url);
    a.setAttribute("download", `${csvTitle}.csv`);
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const downloadPDF = async () => {
    const { default: jsPDF } = await import("jspdf");
    const pdf = new jsPDF();
    const visibleColumns = columns.filter((item) => item.show);
    const bolderTitles = columns.filter((item) => item?.titleFontWeight === "bold");

    // Set starting positions
    const margin = 10;
    let x = 10; // Left margin
    let y = 10; // Top margin
    const lineHeight = 10; // Height between rows
    const pageWidth = pdf.internal.pageSize.getWidth(); // Width of the page
    const pageHeight = pdf.internal.pageSize.getHeight(); // Height of the page
    let tableHeight = 0;

    // Add table header
    pdf.setFontSize(12);
    // pdf.setFont("helvetica", "bold");
    visibleColumns.forEach((column) => {
      pdf.setFont("helvetica", column?.titleFontWeight || "normal");
      pdf.text(String(column.title || ""), x, y); // Ensure title is a string
      // pdf.rect(x-2, y-5, 50, 1);

      y += 10; // Move to the next column position

      if (!column?.border || column?.border !== "none") {
        pdf.line(5, y - 5, 60, y - 5);
      }
    });

    // Reset x and move y down for rows
    x += 50;
    tableHeight = y;
    y = lineHeight;

    // // Add table data
    data.forEach((row) => {
      visibleColumns.forEach((column) => {
        // Check if y exceeds the page height
        if (x > pageWidth - margin) {
          pdf.addPage(); // Add a new page
          x = 10; // Reset x
          y = 10; // Reset y to top margin
          // pdf.setFont("helvetica", "bold");
          visibleColumns.forEach((column) => {
            pdf.setFont("helvetica", column?.titleFontWeight || "normal");
            pdf.text(String(column.title || ""), x, y); // Ensure title is a string
            y += 10; // Move to the next column position
          });
          x += 50;
          y = lineHeight;
        }
        const value = getValueFromPath(row, column.dataIndex);
        const text = Array.isArray(value)
          ? value.join(", ")
          : value !== undefined
            ? String(value) // Convert to string to avoid type issues
            : ""; // Default to empty string if value is undefined

        pdf.setFont("helvetica", column?.fontWeight || "normal");

        pdf.text(text, x, y); // Write value as string
        y += 10; // Move to the next column position
        if (!column?.border || column?.border !== "none") {
          pdf.line(x, y - 5, x + 30, y - 5);
        }
      });
      pdf.line(x - 2, 5, x - 2, y - 5);
      x += 30; // Reset x position for the next row
      y = lineHeight; // Move y down for the next row
    });

    pdf.rect(5, 5, x - 5, tableHeight - 10);
    // Save the PDF file
    pdf.save(`${csvTitle}.pdf`);
  };

  const CustomTable = ({ columns, data, margin }) => {
    return (
      <div style={{ margin: margin }} className={`w-fit ${className}`}>
        <div className="mb-3">
          {/* <HtmlButton onClick={downloadPDF} svgSize={20} outline={true} svgType='download' type='download'/> */}
          {csvDownload && (
            <HtmlButton
              onClick={() => {
                if (csvDownloadFunction) {
                  csvDownloadFunction();
                } else {
                  fileType === "csv" ? downloadCSV() : downloadPDF();
                }
              }}
              svgSize={20}
              outline={true}
              svgType="download"
              type="download"
            />
          )}
        </div>
        <table className="w-full border-t invisible-scrollbar border">
          <tbody className="html-table-body invisible-scrollbar">
            {columns?.map((column, index) => (
              <tr
                key={index}
                className="html-table-row"
                style={{
                  backgroundColor: column?.bg,
                  display: column?.display,
                }}
              >
                <React.Fragment key={column.key}>
                  <th
                    className="html-table-header"
                    style={{
                      whiteSpace: "nowrap",
                      width: "200px",
                      fontWeight: column?.titleFontWeight ? column?.titleFontWeight : "bold",
                      borderBottom: column.border ? column?.border : "1px solid #DDD",
                    }}
                  >
                    {" "}
                    {column.title}
                  </th>
                  {data?.map((row, rowIndex) => (
                    <td
                      colspan={column?.colspan}
                      className={`html-table-data ${
                        column?.colspan > rowIndex && rowIndex > 0 ? "hidden" : ""
                      }`}
                      style={{
                        whiteSpace: "nowrap",
                        textAlign: column?.textAlign,
                        width: column?.width ? column?.width : "auto",
                        fontWeight: column?.fontWeight,
                        borderBottom: column.border ? column?.border : "1px solid #DDD",
                      }}
                    >
                      {column.render
                        ? column.render(getValueFromPath(row, column.dataIndex), row, rowIndex)
                        : Array.isArray(getValueFromPath(row, column.dataIndex))
                          ? getValueFromPath(row, column.dataIndex).join(", ")
                          : getValueFromPath(row, column.dataIndex)}
                    </td>
                  ))}
                </React.Fragment>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };
  return (
    <CustomTable
      margin={margin}
      columns={columns.filter((items) => items?.show === true)}
      data={data}
    />
  );
};
/** @deprecated  */
export const HtmlTableV2 = ({
  columns = [],
  data = [],
  csvTitle = "data",
  margin = "auto",
  fileType = "pdf",
  csvDownloadFunction,
  csvDownload = false,
  className = "",
  loading = false,
}) => {
  // const [containeRe]
  const [containerProperties, setContainerProperties] = useState({});
  const containerRef = useRef();
  const getValueFromPath = (obj, path) => {
    if (Array.isArray(path)) {
      return path.reduce((acc, key) => acc && acc[key], obj);
    } else if (typeof path === "string") {
      return path.split(".").reduce((acc, key) => acc && acc[key], obj);
    }
    return undefined;
  };
  const downloadCSV = () => {
    const csvRows = [];
    const headers = columns
      .filter((item) => item.show)
      .map((column) => {
        csvRows.push(column.title);
      });
    data.forEach((row) => {
      const values = columns
        .filter((item) => item.show)
        .map((column) => {
          const value = getValueFromPath(row, column.dataIndex);
          return Array.isArray(value) ? value.join(", ") : value;
        });
      for (let index = 0; index < values.length; index++) {
        csvRows[index] = [csvRows[index], values[index]].join(",");
      }
    });
    const csvString = csvRows.join("\n");
    const blob = new Blob([csvString], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.setAttribute("href", url);
    a.setAttribute("download", `${csvTitle}.csv`);
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const downloadPDF = async () => {
    const { default: jsPDF } = await import("jspdf");
    const pdf = new jsPDF();
    const visibleColumns = columns.filter((item) => item.show);
    const bolderTitles = columns.filter((item) => item?.titleFontWeight === "bold");

    // Set starting positions
    const margin = 10;
    let x = 10; // Left margin
    let y = 10; // Top margin
    const lineHeight = 10; // Height between rows
    const pageWidth = pdf.internal.pageSize.getWidth(); // Width of the page
    const pageHeight = pdf.internal.pageSize.getHeight(); // Height of the page
    let tableHeight = 0;

    // Add table header
    pdf.setFontSize(12);
    // pdf.setFont("helvetica", "bold");
    visibleColumns.forEach((column) => {
      pdf.setFont("helvetica", column?.titleFontWeight || "normal");
      pdf.text(String(column.title || ""), x, y); // Ensure title is a string
      // pdf.rect(x-2, y-5, 50, 1);

      y += 10; // Move to the next column position

      if (!column?.border || column?.border !== "none") {
        pdf.line(5, y - 5, 60, y - 5);
      }
    });

    // Reset x and move y down for rows
    x += 50;
    tableHeight = y;
    y = lineHeight;

    // // Add table data
    data.forEach((row) => {
      visibleColumns.forEach((column) => {
        // Check if y exceeds the page height
        if (x > pageWidth - margin) {
          pdf.addPage(); // Add a new page
          x = 10; // Reset x
          y = 10; // Reset y to top margin
          // pdf.setFont("helvetica", "bold");
          visibleColumns.forEach((column) => {
            pdf.setFont("helvetica", column?.titleFontWeight || "normal");
            pdf.text(String(column.title || ""), x, y); // Ensure title is a string
            y += 10; // Move to the next column position
          });
          x += 50;
          y = lineHeight;
        }
        const value = getValueFromPath(row, column.dataIndex);
        const text = Array.isArray(value)
          ? value.join(", ")
          : value !== undefined
            ? String(value) // Convert to string to avoid type issues
            : ""; // Default to empty string if value is undefined

        pdf.setFont("helvetica", column?.fontWeight || "normal");

        pdf.text(text, x, y); // Write value as string
        y += 10; // Move to the next column position
        if (!column?.border || column?.border !== "none") {
          pdf.line(x, y - 5, x + 30, y - 5);
        }
      });
      pdf.line(x - 2, 5, x - 2, y - 5);
      x += 30; // Reset x position for the next row
      y = lineHeight; // Move y down for the next row
    });

    pdf.rect(5, 5, x - 5, tableHeight - 10);
    // Save the PDF file
    pdf.save(`${csvTitle}.pdf`);
  };
  useEffect(() => {
    const handleResize = () => {
      if (containerRef.current) {
        setContainerProperties(containerRef?.current);
        // setDivWidth(containerRef.current.offsetWidth);
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize(); // Call it initially to set the width
    return () => {
      window.removeEventListener("resize", handleResize); // Cleanup on unmount
    };
  }, []);
  const CustomTable = ({ columns, data, margin }) => {
    return (
      // <div style={{ margin: margin,height:"auto",maxHeight:"100%",overflow:'scroll' }} className={`w-fit ${className} invisible-scrollbar`}>
      //   <table style={{}} className="w-full border-t  border">
      //     <tbody style={{position:'relative'}} className=" ">
      //       {columns?.map((column, index) => (
      //         <tr
      //           key={index}

      //           style={{
      //             backgroundColor: column?.bg,
      //             display: column?.display,
      //              height:index!== 0?'63px':'null',

      //           }}
      //         >
      //           <React.Fragment key={column.key}>
      //             <th

      //               style={{
      //               }}
      //             >
      //               {" "}
      //               {column.title}
      //             </th>
      //             {data?.map((row, rowIndex) => (
      //               <td
      //                 colspan={column?.colspan}
      //                 style={{

      //                 }}
      //               >
      //                 {column.render
      //                   ? column.render(
      //                       getValueFromPath(row, column.dataIndex),
      //                       row,
      //                       rowIndex
      //                     )
      //                   : Array.isArray(getValueFromPath(row, column.dataIndex))
      //                   ? getValueFromPath(row, column.dataIndex).join(", ")
      //                   : getValueFromPath(row, column.dataIndex)}
      //               </td>
      //             ))}
      //           </React.Fragment>
      //         </tr>
      //       ))}
      //     </tbody>
      //   </table>
      // </div>
      <div
        ref={containerRef}
        style={{
          margin,
          maxHeight: "100%",
          overflow: loading ? "hidden" : "auto",
          minWidth: "100%",
          padding: "0px",
          borderCollapse: "separate",
          borderSpacing: "0",
          position: "relative",
        }}
        className={`relative invisible-scrollbar custom-vc-table2`}
      >
        {loading && (
          <div
            id="table-loader"
            style={{
              position: "absolute", // Changed from fixed (usually better for dialogs/modals)
              backgroundColor: "transparent", // Semi-transparent red
              color: "white", // Text color
              padding: "20px",
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              width: "fit-content",
              minWidth: "100%",
              height: "100%",
              top: "50%",
              left: "50%",
              zIndex: 1000, // Higher z-index for overlay contexts
              transform: "translate(-50%, -50%)",
              textAlign: "center",
              lineHeight: 1.5,
              animation: "fadeIn 0.3s ease-out", // Optional animation
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <SvgIcon color="rgb(136,109,254)" size="35" type={"spinner"} />
          </div>
        )}
        <table
          style={{
            width: "100%",
            padding: "0px",
            margin: "0px",
            borderCollapse: "separate",
            borderSpacing: "0",
            // overflow:"hidden"
          }}
          className="border-collapse table-auto min-w-max"
        >
          <tbody style={{ padding: "0px", margin: "0px" }}>
            {columns?.map((column, index) => (
              <tr
                key={index}
                style={{
                  height: index === 0 ? "50px" : "63px",
                  // width:"fit-content",
                  // marginRight:"2.5%",
                  ...(index === 0 && {
                    overflowY: "hidden",
                  }),
                }}
              >
                <th
                  style={{
                    position: "sticky",
                    left: 0,
                    top: index === 0 ? 0 : undefined,
                    zIndex: index === 0 ? 5 : 3,
                    background: "rgb(240,237,255)",
                    padding: "8px",
                    textAlign: "left",
                    // minWidth: "150px",
                    fontSize: "14px",
                    fontWeight: "500",
                    lineHeight: "15px",
                    color: "rgb(100, 98, 98)",
                    ...(index === 0 && {}),
                  }}
                >
                  {column.title}
                </th>

                {data?.map((row, rowIndex) => (
                  <td
                    key={`${index}-${rowIndex}`}
                    style={{
                      left: 0,
                      top: index === 0 ? 0 : undefined,
                      zIndex: index === 0 ? 4 : 3,
                      backgroundColor: index === 0 ? "rgb(240,237,255)" : "white",
                      padding: "8px",
                      textAlign: "center",
                      // minWidth: "150px",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "22px",
                      color: "rgb(126, 126, 127)",
                      ...(index === 0 && {
                        position: "sticky",
                        fontSize: "14px",
                        fontWeight: "500",
                        lineHeight: "15px",
                        color: "rgb(100, 98, 98)",
                      }),
                    }}
                  >
                    {column.render
                      ? column.render(getValueFromPath(row, column.dataIndex), row, rowIndex)
                      : Array.isArray(getValueFromPath(row, column.dataIndex))
                        ? getValueFromPath(row, column.dataIndex).join(", ")
                        : getValueFromPath(row, column.dataIndex)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };
  return (
    <CustomTable
      margin={margin}
      columns={columns.filter((items) => items?.show === true)}
      data={data}
    />
  );
};

//Edited for vehicle-reports
/** @deprecated  */
export const HtmlTableN = ({
  columns = [],
  data = [],
  csvTitle = "data",
  margin = "auto",
  fileType = "pdf",
  mergeColumn = false,
  mergeRowTitle = "",
  searchElement,
  element,
  loading = false,
  errorMessage = "",
  frequency,
}) => {
  const getValueFromPath = (obj, path) => {
    if (Array.isArray(path)) {
      return path.reduce((acc, key) => acc && acc[key], obj);
    } else if (typeof path === "string") {
      return path.split(".").reduce((acc, key) => acc && acc[key], obj);
    }
    return undefined;
  };
  const downloadCSVOld = () => {
    const csvRows = [];

    // Create header row
    const headers = columns
      .filter((item) => item.show)
      .map((column) => {
        csvRows.push(column.title);
      });
    // csvRows.push(headers);

    // Create data rows
    data.forEach((row) => {
      const values = columns
        .filter((item) => item.show)
        .map((column) => {
          const value = getValueFromPath(row, column.dataIndex);
          return Array.isArray(value) ? value.join(", ") : value;
        });
      for (let index = 0; index < values.length; index++) {
        csvRows[index] = [csvRows[index], values[index]].join(",");
      }
    });

    // Create a Blob from the CSV string
    const csvString = csvRows.join("\n");
    const blob = new Blob([csvString], { type: "text/csv" });
    const url = URL.createObjectURL(blob);

    // Create a link element and trigger the download
    const a = document.createElement("a");
    a.setAttribute("href", url);
    a.setAttribute("download", `${csvTitle}.csv`);
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const downloadCSV = () => {
    const csvRows = [];

    const visibleColumns = columns.filter((item) => item.show);

    visibleColumns.forEach((column) => {
      // Use csvTitle if available, otherwise fall back to title (for non-React element titles)
      const headerTitle = column.csvTitle || (typeof column.title === "string" ? column.title : "");
      csvRows.push([headerTitle]); // First cell is the column title
    });

    data.forEach((record) => {
      visibleColumns.forEach((column, index) => {
        let value = getValueFromPath(record, column.dataIndex);

        // Handle "Date" column specifically using your logic
        // Check csvTitle first, then title
        const columnName = column.csvTitle || column.title;
        if (columnName === "Date") {
          if (frequency === "weekly") {
            value = record?.week_start
              ? `${DateFormatter(
                  record.week_start,
                  false,
                  "DD MMM"
                )} to ${DateFormatter(record.week_end, false, "DD MMM YY")}`
              : "";
          } else if (frequency === "monthly") {
            value = record?.MONTH ? DateFormatter(record.MONTH, false, "MMM YY") : "";
          } else {
            value = convertToISTFormatted(value);
          }
        } else if (columnName === "Hub") {
          value = textBeautifyFunction(value);
        } else {
          value = Array.isArray(value) ? value.join(", ") : (value ?? "");
        }

        csvRows[index].push(value);
      });
    });

    const csvString = csvRows.map((row) => row.join(",")).join("\n");

    const blob = new Blob([csvString], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${csvTitle}.csv`;
    link.click();
    URL.revokeObjectURL(url);
  };

  const downloadPDF = async () => {
    const { default: jsPDF } = await import("jspdf");
    const pdf = new jsPDF();
    const visibleColumns = columns.filter((item) => item.show);
    const bolderTitles = columns.filter((item) => item?.titleFontWeight === "bold");

    // Set starting positions
    const margin = 10;
    let x = 10; // Left margin
    let y = 10; // Top margin
    const lineHeight = 10; // Height between rows
    const pageWidth = pdf.internal.pageSize.getWidth(); // Width of the page
    const pageHeight = pdf.internal.pageSize.getHeight(); // Height of the page
    let tableHeight = 0;

    // Add table header
    pdf.setFontSize(12);
    // pdf.setFont("helvetica", "bold");
    visibleColumns.forEach((column) => {
      pdf.setFont("helvetica", column?.titleFontWeight || "normal");
      pdf.text(String(column.title || ""), x, y); // Ensure title is a string
      // pdf.rect(x-2, y-5, 50, 1);

      y += 10; // Move to the next column position

      if (!column?.border || column?.border !== "none") {
        pdf.line(5, y - 5, 60, y - 5);
      }
    });

    // Reset x and move y down for rows
    x += 50;
    tableHeight = y;
    y = lineHeight;

    // // Add table data
    data.forEach((row) => {
      visibleColumns.forEach((column) => {
        // Check if y exceeds the page height
        if (x > pageWidth - margin) {
          pdf.addPage(); // Add a new page
          x = 10; // Reset x
          y = 10; // Reset y to top margin
          // pdf.setFont("helvetica", "bold");
          visibleColumns.forEach((column) => {
            pdf.setFont("helvetica", column?.titleFontWeight || "normal");
            pdf.text(String(column.title || ""), x, y); // Ensure title is a string
            y += 10; // Move to the next column position
          });
          x += 50;
          y = lineHeight;
        }
        const value = getValueFromPath(row, column.dataIndex);
        const text = Array.isArray(value)
          ? value.join(", ")
          : value !== undefined
            ? String(value) // Convert to string to avoid type issues
            : ""; // Default to empty string if value is undefined

        pdf.setFont("helvetica", column?.fontWeight || "normal");

        pdf.text(text, x, y); // Write value as string
        y += 10; // Move to the next column position
        if (!column?.border || column?.border !== "none") {
          pdf.line(x, y - 5, x + 30, y - 5);
        }
      });
      pdf.line(x - 2, 5, x - 2, y - 5);
      x += 30; // Reset x position for the next row
      y = lineHeight; // Move y down for the next row
    });

    pdf.rect(5, 5, x - 5, tableHeight - 10);
    // Save the PDF file
    pdf.save(`${csvTitle}.pdf`);
  };

  const groupBy = (array, key) => {
    return array.reduce((result, item) => {
      const groupKey = item[key];
      if (!result[groupKey]) {
        result[groupKey] = [];
      }
      result[groupKey].push(item);
      return result;
    }, {});
  };
  // const [tableWidth, setTableWidth] = useState(window.innerWidth - 40);
  const [tableWidth, setTableWidth] = useState(0);

  // Debounce utility function
  const debounce = (func, delay) => {
    let timeoutId;
    return function (...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func.apply(this, args), delay);
    };
  };

  // Function to calculate and set table width based on sidebar
  const updateTableWidth = () => {
    const sidebar = document.querySelector(".sidebar-dashboard-container");
    const sidebarWidth = sidebar?.offsetWidth || 0;
    const availableWidth = window.innerWidth - sidebarWidth - 20; // subtract sidebar and margin
    setTableWidth(availableWidth);
  };

  // Debounced version of updateTableWidth to prevent vibration during sidebar transitions
  const debouncedUpdateTableWidth = useCallback(
    debounce(() => {
      updateTableWidth();
    }, 100), // 100ms debounce to allow CSS transition to complete
    []
  );

  useEffect(() => {
    // Initial table width calculation
    updateTableWidth();

    // Set up window resize listener with debouncing to prevent modal vibration
    window.addEventListener("resize", debouncedUpdateTableWidth);

    // Observe sidebar width changes
    const sidebar = document.querySelector(".sidebar-dashboard-container");
    let resizeObserver;

    if (sidebar) {
      resizeObserver = new ResizeObserver(() => {
        debouncedUpdateTableWidth();
      });
      resizeObserver.observe(sidebar);
    }

    // Cleanup on unmount
    return () => {
      window.removeEventListener("resize", debouncedUpdateTableWidth);
      resizeObserver?.disconnect();
    };
  }, []);

  const CustomTable = ({ columns, data, margin }) => {
    const groupedByEndDate = groupBy(data, "end_date");

    const getGroupCountByDate = (date) => {
      return groupedByEndDate[date]?.length || 1;
    };

    const isFirstInGroup = (row, date) => {
      return groupedByEndDate[date]?.[0] === row;
    };

    return (
      <div className={`w-full overflow-auto`}>
        <div className="flex flex-col md:flex-row justify-between items-center w-full pb-2 pt-2 ">
          {/* Left side - searchElement */}
          <div className="flex gap-4 w-full md:w-auto">{searchElement}</div>
          {/* Right side - HtmlButton and element */}
          {/* <div className="flex gap-4 pr-1" > */}
          <div className="flex flex-wrap md:flex-nowrap items-center justify-start md:justify-end gap-2 md:gap-4 w-full md:w-auto mt-2 md:mt-0">
            <HtmlButton
              onClick={fileType === "csv" ? downloadCSV : downloadPDF}
              svgSize={14}
              outline={true}
              svgType="download"
              type="download"
              text={"CSV"}
              style={{
                // padding: "5px 14px",
                height: "2rem",
                borderRadius: "24px",
                fontSize: "14px",
                backgroundColor: "white",
                borderColor: "#9ca3af",
                color: "#4b5563",
              }}
            />
            {element}
          </div>
        </div>

        {!loading ? (
          errorMessage !== "" ? (
            errorMessage
          ) : (
            <div
              id="vehicle-report-table"
              className={`w-full overflow-auto max-h-[80dvh] md:max-h-[90dvh]`} // max height changing as on small screen header is on top, on medium onwards its on sidebar
              style={{
                width: "100%",
                marginLeft: 0,
                marginRight: 0,
                paddingLeft: 0,
                paddingRight: 0,
                // maxHeight:`${window.innerHeight - 110}`
              }}
            >
              <table className="html-table-container" style={{ width: "100%", minWidth: "100%" }}>
                <tbody className="html-table-body">
                  {columns?.map((column, index) => (
                    <tr key={index} className="html-table-row">
                      <React.Fragment key={column.key}>
                        <th
                          className="html-table-header bg-white px-4 py-2 text-left font-bold border-b border-gray-300"
                          style={{
                            fontWeight: column?.titleFontWeight || "bold",
                            borderBottom: column?.border || "1px solid #DDD",
                            backgroundColor: column?.backgroundColor || "transparent",
                            width: column?.width || "auto",
                            whiteSpace: "nowrap",
                            ...(column?.fixedLeft && {
                              position: "sticky",
                              left: 0,
                              zIndex: 20,
                            }),
                            ...(column?.fixedTop && {
                              position: "sticky",
                              top: 0,
                              zIndex: 30,
                            }),
                            ...(column?.fixedBoth && {
                              position: "sticky",
                              top: "41px",
                              zIndex: 30,
                            }),
                          }}
                        >
                          {column.title}
                        </th>

                        {data?.map((row, rowIndex) => {
                          const cellValue = getValueFromPath(row, column.dataIndex);

                          // Custom colSpan logic for "Date"
                          if (column.title === "Date") {
                            const showDateCell = isFirstInGroup(row, cellValue);
                            const colSpan = getGroupCountByDate(cellValue);

                            if (!showDateCell) return null;

                            return (
                              <td
                                key={`${rowIndex}-${column.key}`}
                                colSpan={colSpan}
                                className="html-table-data sticky top-0 z-10 "
                                style={{
                                  // width: "100px",
                                  fontWeight: column?.fontWeight,
                                  borderBottom: column?.border || "1px solid #DDD",
                                  backgroundColor: column?.backgroundColor || "transparent", // Column-specific background
                                  // color: column?.color || "inherit", // Column-specific text color
                                  textAlign: column?.align,
                                  width: column?.width || "300px",
                                  whiteSpace: "nowrap", // Column-specific width
                                }}
                              >
                                {column.render
                                  ? column.render(cellValue, row, rowIndex)
                                  : cellValue}
                              </td>
                            );
                          }

                          // Default column rendering
                          return (
                            <td
                              key={`${rowIndex}-${column.key}`}
                              className="html-table-data"
                              style={{
                                fontWeight: column?.fontWeight,
                                borderBottom: column?.border || "1px solid #DDD",
                                backgroundColor: column?.backgroundColor || "transparent",
                                textAlign: column?.align,
                                width: column?.width || "100px",
                                ...(column?.fixedEntireRow && {
                                  position: "sticky",
                                  top: "41px",
                                  zIndex: 10,
                                }),
                              }}
                              colSpan={column.colSpan || 1}
                            >
                              {column.render
                                ? column.render(cellValue, row, rowIndex)
                                : Array.isArray(cellValue)
                                  ? cellValue.join(", ")
                                  : cellValue}
                            </td>
                          );
                        })}
                      </React.Fragment>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )
        ) : (
          <p className="text-gray-400 text-lg">Hold On! We are loading data</p>
        )}
      </div>
    );
  };
  return (
    <CustomTable
      margin={margin}
      columns={columns.filter((items) => items?.show === true)}
      data={data}
    />
  );
};
/** @deprecated  */
export const HtmlDocumentModal = ({
  text,
  imageValue,
  download = false,
  title = "",
  onClose = () => {},
  addMore = false,
  onAddMore = () => {},
  addMoreText,
  activeIndex,
  labels = [],
}) => {
  const reduxState = useSelector((state) => state);
  const dispatch = useDispatch();
  const [urls, setUrls] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [downloadImageUrl, setDownloadImageUrl] = useState("");
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [downloadable, setDownloadable] = useState(false);
  const [documentTitle, setDocumentTitle] = useState("");
  useEffect(() => {
    if (reduxState.documentsModal.value !== "") {
      const normalUrls = normalizeImageUrl(reduxState.documentsModal.value);
      setUrls(normalUrls);
      setDownloadImageUrl(normalUrls[0]);
      setDownloadable(reduxState.documentsModal.downloadable);
      setDocumentTitle(reduxState.documentsModal.title);
      setShowModal(true);
    }
  }, [reduxState.documentsModal]);
  useEffect(() => {
    if (activeIndex && activeIndex !== currentIndex) {
      setCurrentIndex(activeIndex);
      setDownloadImageUrl(urls[activeIndex]);
    }
  }, [activeIndex]);
  useEffect(() => {
    if (fieldContainsValue(imageValue)) {
      const normalUrls = normalizeImageUrl(imageValue);
      setUrls(normalUrls);
      setDownloadImageUrl(normalUrls[0]);
      setDownloadable(download);
      setDocumentTitle(title);
      setShowModal(true);
    }
  }, [imageValue]);
  const normalizeImageUrl = (imageUrl) => {
    if (Array.isArray(imageUrl)) {
      return imageUrl;
    } else if (typeof imageUrl === "string") {
      try {
        const parsedArray = JSON.parse(imageUrl);
        if (Array.isArray(parsedArray)) {
          return parsedArray;
        }
      } catch (e) {
        return [imageUrl];
      }
    } else {
      return [];
    }
  };
  const clear = () => {
    setShowModal(false);
    dispatch(clearDocumentModalValue());
    setUrls([]);
    setDownloadImageUrl("");
    onClose();
  };
  function isPdfUrl(url) {
    return url?.toLowerCase()?.endsWith(".pdf");
  }
  const handleLeftClick = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + urls.length) % urls.length);
    setDownloadImageUrl(urls[(currentIndex - 1 + urls.length) % urls.length]);
  };
  const handleRightClick = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % urls.length);
    setDownloadImageUrl(urls[(currentIndex + 1) % urls.length]);
  };
  const handleDownload = async () => {
    setDownloadLoading(true);
    try {
      const response = await fetch(downloadImageUrl);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = documentTitle;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("There was an error downloading the image:", error);
    }
    setDownloadLoading(false);
  };
  return (
    <div className="flex justify-center items-center invisible-scrollbar">
      <ShowContentModal
        open={showModal}
        close={clear}
        mask={true}
        title={labels ? labels[currentIndex] : documentTitle}
        // loading={ true}
        element={
          urls?.length > 0 && (
            <div className="flex relative h-auto flex-col m-auto items-center justify-center mb-0 pb-0 invisible-scrollbar">
              {!isPdfUrl(urls[currentIndex]) && (
                <img
                  src={urls[currentIndex]}
                  alt={text}
                  className="w-full h-auto object-cover rounded-md"
                />
              )}
              {isPdfUrl(urls[currentIndex]) && (
                <div
                  className="mr-12 ml-12"
                  style={{ width: "350px", height: "400px", overflow: "auto" }}
                >
                  <iframe
                    key={urls[currentIndex]}
                    src={urls[currentIndex]}
                    title="PDF Viewer"
                    width="100%"
                    height="100%"
                    style={{ border: "none", margin: "auto" }}
                  ></iframe>
                </div>
              )}
              {urls.length > 1 && (
                <div className="w-full flex justify-center items-center gap-2 mt-2">
                  <button
                    onClick={() => {
                      handleLeftClick();
                    }}
                  >
                    <SvgIcon size={25} type="left-arrow-point" />
                  </button>
                  <button
                    onClick={() => {
                      handleRightClick();
                    }}
                  >
                    <SvgIcon size={25} type="right-arrow-point" />
                  </button>
                </div>
              )}
              <div className={`flex justify-center mt-2 gap-5`}>
                {urls.length > 0 && downloadable && (
                  <HtmlButton
                    loading={downloadLoading}
                    onClick={handleDownload}
                    type="primary"
                    text={`${downloadLoading ? "Please wait" : "Download"}`}
                  />
                )}
                {addMore && onAddMore && (
                  <HtmlButton
                    onClick={() => {
                      clear();
                      onAddMore(currentIndex);
                    }}
                    type="primary"
                    text={addMoreText ? addMoreText : `Add Another`}
                  />
                )}
              </div>
            </div>
          )
        }
      />
    </div>
  );
};

/** @deprecated  */
export const HtmlDocumentModalButtons = ({
  value,
  type = "buttons",
  text = "View",
  downloadable = false,
  title = "Document",
}) => {
  const dispatch = useDispatch();
  const setDocumentValue = (value) => {
    const data = { value: value, downloadable: downloadable, title: title };
    dispatch(setDocumentModalValue(data));
  };
  return (
    <div className="flex justify-center items-center">
      {type === "buttons" &&
        (fieldContainsValue(value) ? (
          <HtmlButton
            onClick={() => {
              setDocumentValue(value);
            }}
            svgType="upload-done"
            style={{ textDecoration: "underline", color: "green" }}
            outline={true}
            text={text}
          />
        ) : (
          <HtmlButton svgType="upload" text="Upload Image" type={"primary"} outline={true} />
        ))}
      {type === "text" && fieldContainsValue(value) && (
        <HtmlButton
          onClick={() => {
            setDocumentValue(value);
          }}
          type="default"
          svgType="upload-done"
          style={{
            textDecoration: "underline",
            color: "green",
            padding: "0px",
            border: "none",
          }}
          outline={true}
          text={text}
        />
      )}
    </div>
  );
};
/** @deprecated  */
export const HtmlDocumentModalCButtons = ({}) => {
  return <div></div>;
};
/** @deprecated  */
export const HtmlDate = ({
  oneTimeEditMode = false,
  allTimeEditMode = false,
  disabled = false,
  min,
  max,
  mandatory = false,
  required = false,
  placeholder,
  value,
  updatedValue,
  onChange = () => {},
  title,
  name,
  format = "yyyy-mm-ddd",
  height = "42px",
  textSize = "14px",
  pattern,
  style,
  containerSize = "fit",
}) => {
  const [access, setAccess] = useState(false);
  useEffect(() => {
    if (oneTimeEditMode) {
      setAccess(!fieldContainsValue(updatedValue));
    }
    if (allTimeEditMode) {
      setAccess(allTimeEditMode);
    }
    if (disabled) {
      setAccess(!disabled);
    }
  }, [oneTimeEditMode, disabled, value, updatedValue, allTimeEditMode]);
  return (
    <div className={`w-${containerSize}`}>
      {title && (
        <h3 className={`text-[${textSize}] font-publicSans text-[#4B465C] mb-1 flex`}>
          {title} {mandatory && <SvgIcon size={10} type="star" />}
        </h3>
      )}
      <input
        style={style}
        min={min}
        max={max}
        format={format}
        type="date"
        name={name}
        pattern={pattern}
        className={`h-[${height}] ${
          required ? "border-red-500" : ""
        } form-input p-1 w-full text-[${textSize}] font-light text-gray-600 bg-transparent border border-gray-300 rounded-md focus:outline-none focus:ring-0 `}
        // placeholder={placeholder}
        value={value?.slice(0, 10)}
        onChange={onChange}
        disabled={!access}
        placeholder={placeholder}
      ></input>
      {required && <p className="text-[13px] text-red-500">Required</p>}
    </div>
  );
};
/** @deprecated  */
export const HtmlLinkOpen = ({ text, url }) => {
  return (
    <Link className="underline" to={url}>
      {text}
    </Link>
  );
};
/** @deprecated  */
export const HtmlDropdownContainer = ({
  value,
  children,
  triggerMethod = "click",
  zIndex = 100,
  className = "",
  style = {},
  required = false,
  textSize = "16px",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen && triggerMethod === "click") {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, triggerMethod]);

  // Click handler for trigger
  const handleTriggerClick = () => {
    if (triggerMethod === "click") {
      setIsOpen(!isOpen);
    }
  };

  // Hover handlers
  const handleMouseEnter = () => {
    if (triggerMethod === "hover") {
      setIsOpen(true);
    }
  };

  const handleMouseLeave = () => {
    if (triggerMethod === "hover") {
      setIsOpen(false);
    }
  };

  return (
    <div
      className="relative inline-block"
      ref={dropdownRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {/* Trigger Element */}
      <div
        onClick={handleTriggerClick}
        className={`h-[42px] flex items-center  ${
          required ? "border-red-500" : ""
        } form-input p-1 w-full text-[${textSize}] font-light text-gray-600 bg-transparent border border-gray-300 rounded-md focus:outline-none focus:ring-0 px-2`}
      >
        {value}
        <HtmlButton
          style={{ borderLeft: "1px solid rgb(209,213,218)" }}
          className=" h-full px-1 ml-1"
          svgType="down-arrow-point"
        />
      </div>

      {/* Dropdown Content */}
      {isOpen && (
        <div
          className={`absolute bg-white shadow-lg rounded-lg p-2 mt-1 ${className}`}
          style={{ zIndex, minWidth: "100px", maxWidth: "250px", ...style }}
        >
          {children}
        </div>
      )}
    </div>
  );
};
/** @deprecated  */
const getValidDates = (daysOption) => {
  if (!daysOption.length) return null; // Allow all days

  const dayMap = {
    Sunday: 0,
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
  };

  const validDays = daysOption.map((day) => dayMap[day]);

  return (date) => validDays.includes(date.getDay());
};
/** @deprecated  */
const getValidDays = (daysArray) => {
  if (!daysArray.length) return null; // Allow all days

  const dayMap = {
    Sunday: 0,
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
  };

  const validDays = daysArray.map((day) => dayMap[day]);

  return (date) => validDays.includes(date.getDay());
};
/** @deprecated  */
export const HtmlDateRangePicker = ({
  textSize = "15px",
  required = false,
  triggerMethod = "click",
  daysOption = [],
  startDaysOption = [],
  endDaysOption = [],
  minDate,
  maxDate,
  onChange = () => {},
  startDate = new Date(),
  endDate = new Date(),
  height = "42px",
}) => {
  const isValidDate = getValidDays(daysOption);
  const isValidStartDate = getValidDays(startDaysOption);
  const isValidEndDate = getValidDays(endDaysOption);

  const [state, setState] = useState([
    { startDate: startDate, endDate: endDate, key: "selection" },
  ]);
  const [isOpen, setIsOpen] = useState(false);
  const [activeSelection, setActiveSelection] = useState("start");

  const dropdownRef = useRef(null);
  const triggerRef = useRef(null);
  const [dropdownPosition, setDropdownPosition] = useState({
    top: 0,
    left: 0,
  });

  // close when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen && triggerMethod === "click") {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen, triggerMethod]);

  // dropdown positioning (left/right + top/bottom)
  useEffect(() => {
    if (isOpen && dropdownRef.current && triggerRef.current) {
      const triggerRect = triggerRef.current.getBoundingClientRect();
      const dropdownWidth = dropdownRef.current.offsetWidth || 320;
      const dropdownHeight = dropdownRef.current.offsetHeight || 350;
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      let left = triggerRect.left;
      // prevent overflow right
      if (left + dropdownWidth > viewportWidth - 10) {
        left = viewportWidth - dropdownWidth - 10;
      }
      // prevent overflow left
      if (left < 10) left = 10;

      let top = triggerRect.bottom + window.scrollY;
      // if not enough space below → open above
      if (top + dropdownHeight > viewportHeight + window.scrollY) {
        top = triggerRect.top + window.scrollY - dropdownHeight - 8;
      }

      setDropdownPosition({ top, left });
    }
  }, [isOpen]);

  const handleSelect = (ranges) => {
    const { startDate, endDate } = ranges?.selection;

    if (isValidStartDate && activeSelection === "start" && !isValidStartDate(startDate)) return;

    if (isValidEndDate && activeSelection === "end" && !isValidEndDate(endDate)) return;

    const previousStartDate = state[0]?.startDate;
    const newStartDate = ranges?.selection?.startDate;
    const previousEndDate = state[0]?.endDate;
    const newEndDate = ranges?.selection?.endDate;

    if (previousStartDate !== newStartDate) {
      setActiveSelection("end");
    } else if (previousEndDate !== newEndDate) {
      setActiveSelection("start");
    }

    setState([ranges?.selection]);
    onChange({
      startDate: ranges?.selection?.startDate,
      endDate: ranges?.selection?.endDate,
    });
  };

  const handleTriggerClick = () => {
    if (triggerMethod === "click") setIsOpen(!isOpen);
  };

  const handleMouseEnter = () => {
    if (triggerMethod === "hover") setIsOpen(true);
  };

  const handleMouseLeave = () => {
    if (triggerMethod === "hover") setIsOpen(false);
  };

  return (
    <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <div
        ref={triggerRef}
        onClick={handleTriggerClick}
        className={`daterange-container flex items-center h-[${height}] w-full text-[${textSize}]
        font-light text-gray-600 bg-transparent border border-gray-300 rounded-full px-2
        ${required ? "border-red-500" : ""} bg-white`}
      >
        {state[0]?.startDate?.toLocaleDateString()} - {state[0]?.endDate?.toLocaleDateString()}
      </div>

      {isOpen && (
        <div
          ref={dropdownRef}
          style={{
            position: "absolute",
            top: dropdownPosition.top,
            left: dropdownPosition.left,
            zIndex: 50,
          }}
          className="bg-white shadow-lg rounded-lg p-2"
        >
          <DateRange
            ranges={state}
            onChange={handleSelect}
            editableDateInputs={false}
            dragSelectionEnabled={true}
            showMonthAndYearPickers={true}
            showSelectionPreview={true}
            minDate={minDate}
            maxDate={maxDate}
            disabledDay={(date) =>
              (isValidDate && !isValidDate(date)) ||
              (isValidStartDate && !isValidStartDate(date) && activeSelection === "start") ||
              (isValidEndDate && !isValidEndDate(date) && activeSelection === "end")
            }
            onShownDateChange={(date) => {
              if (isSameDay(date, state[0].startDate)) {
                setActiveSelection("start");
              } else if (isSameDay(date, state[0].endDate)) {
                setActiveSelection("end");
              }
            }}
          />
        </div>
      )}
    </div>
  );
};
/** @deprecated  */
export const HtmlDateRangePickerN = ({
  textSize = "15px",
  required = false,
  triggerMethod = "click",
  daysOption = [],
  startDaysOption = [],
  endDaysOption = [],
  minDate = new Date(2022, 0, 1), // January 1, 2020
  maxDate = new Date(), // Today's date - prevents future date selection
  onChange = () => {},
  startDate = new Date(),
  endDate = new Date(),
  height = "42px",
}) => {
  const isValidDate = getValidDays(daysOption);
  const isValidStartDate = getValidDays(startDaysOption);
  const isValidEndDate = getValidDays(endDaysOption);

  const [state, setState] = useState([
    {
      startDate: startDate,
      endDate: endDate,
      key: "selection",
    },
  ]);
  const [isOpen, setIsOpen] = useState(false);
  const [activeSelection, setActiveSelection] = useState("start"); // Track active date selection
  const dropdownRef = useRef(null);
  const triggerRef = useRef(null);
  const [dropdownPosition, setDropdownPosition] = useState({
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
  });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen && triggerMethod === "click") {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, triggerMethod]);
  useEffect(() => {
    if (isOpen && dropdownRef.current && triggerRef.current) {
      const triggerRect = triggerRef.current.getBoundingClientRect();
      const dropdownWidth = dropdownRef.current.offsetWidth || 320;
      const dropdownHeight = dropdownRef.current.offsetHeight || 350;
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      const scrollY = window.scrollY;
      const scrollX = window.scrollX;

      // Calculate left position - center align on mobile, align to trigger on desktop
      let left;
      let transform = "none";
      const isMobile = viewportWidth < 768;

      if (isMobile) {
        // On mobile: center the calendar in the viewport using transform
        left = viewportWidth / 2;
        transform = "translateX(-50%)";
      } else {
        // On desktop: align to trigger element
        left = triggerRect.left + scrollX;

        // Prevent overflow on the right
        if (left + dropdownWidth > viewportWidth + scrollX - 10) {
          left = viewportWidth + scrollX - dropdownWidth - 10;
        }
      }

      // Prevent overflow on the left
      if (left - (isMobile ? dropdownWidth / 2 : 0) < scrollX + 10) {
        if (isMobile) {
          left = scrollX + 10 + dropdownWidth / 2;
        } else {
          left = scrollX + 10;
        }
      }

      // Calculate top position - position below trigger with spacing
      let top = triggerRect.bottom + scrollY + 8;

      // If not enough space below, position above
      if (top + dropdownHeight > viewportHeight + scrollY - 10) {
        top = triggerRect.top + scrollY - dropdownHeight - 8;
      }

      // Ensure it doesn't go above viewport
      if (top < scrollY + 10) {
        top = scrollY + 10;
      }
      // const triggerRect = triggerRef.current.getBoundingClientRect(); // Get parent div position

      setDropdownPosition({
        top,
        left,
        transform,
        right: triggerRect.right,
        bottom: triggerRect.bottom,
      });
    }
  }, [isOpen]);

  const handleSelect = (ranges) => {
    const { startDate: newStartDate, endDate: newEndDate } = ranges?.selection;
    const prevStartDate = state[0]?.startDate;
    const prevEndDate = state[0]?.endDate;

    // Validations
    if (isValidStartDate && activeSelection === "start" && !isValidStartDate(newStartDate)) {
      return;
    }

    if (isValidEndDate && activeSelection === "end" && !isValidEndDate(newEndDate)) {
      return;
    }

    // Update state
    setState([ranges?.selection]);

    // Handle transition from start → end
    if (activeSelection === "start" && newStartDate !== prevStartDate) {
      setActiveSelection("end");
      return; // Don't close yet, wait for end
    }

    // Handle end date selection
    if (activeSelection === "end" && newEndDate !== prevEndDate) {
      setIsOpen(false); // Close only after both selected
      setActiveSelection("start");
    }
    onChange({ startDate: newStartDate, endDate: newEndDate });
  };

  const handleTriggerClick = () => {
    if (triggerMethod === "click") {
      setIsOpen(!isOpen);
    }
  };

  const handleMouseEnter = () => {
    if (triggerMethod === "hover") {
      setIsOpen(true);
    }
  };

  const handleMouseLeave = () => {
    if (triggerMethod === "hover") {
      setIsOpen(false);
    }
  };

  return (
    <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <div
        ref={triggerRef}
        onClick={handleTriggerClick}
        className={`daterange-container h-[${height}] flex items-center ${
          required ? "border-red-500" : ""
        } form-input p-1 w-full text-[${textSize}] font-light text-gray-600 bg-transparent border bg-white border-gray-400 rounded-full focus:outline-none focus:ring-0 px-2`}
      >
        {state[0]?.startDate?.toLocaleDateString()} - {state[0]?.endDate?.toLocaleDateString()}
        {/* {state[0]?.startDate} - {state[0]?.endDate} */}
      </div>
      {isOpen && (
        <div
          ref={dropdownRef}
          style={{
            position: "fixed",
            top: `${dropdownPosition.top}px`,
            left: `${dropdownPosition.left}px`,
            transform: dropdownPosition.transform || "none",
            zIndex: 9999,
            maxWidth: "95vw",
          }}
          className="bg-white shadow-lg rounded-lg p-2"
        >
          <div style={{ width: "100%", overflow: "auto", maxHeight: "90vh" }}>
            <DateRange
              ranges={state}
              onChange={handleSelect}
              editableDateInputs={false}
              dragSelectionEnabled={true}
              showMonthAndYearPickers={true}
              showSelectionPreview={true}
              minDate={minDate}
              maxDate={maxDate}
              disabledDay={(date) =>
                (isValidDate && !isValidDate(date)) ||
                (isValidStartDate && !isValidStartDate(date) && activeSelection === "start") ||
                (isValidEndDate && !isValidEndDate(date) && activeSelection === "end")
              }
              onShownDateChange={(date) => {
                if (isSameDay(date, state[0].startDate)) {
                  setActiveSelection("start");
                } else if (isSameDay(date, state[0].endDate)) {
                  setActiveSelection("end");
                }
              }}
              className="rounded-full"
            />
          </div>
        </div>
      )}
    </div>
  );
};
/** @deprecated  */
export const HtmlRemainingFields = ({ fields = [] }) => {
  function transformFieldName(fieldName) {
    let transformed = fieldName.replace(/_/g, " ");
    transformed = transformed.replace(/([a-z])([A-Z])/g, "$1 $2");
    transformed = transformed.replace(/\b\w/g, (char) => char.toUpperCase());
    return transformed;
  }
  return (
    <div className="w-auto  mt-2  ">
      <h5 className="my-5">Remaining Fields</h5>
      <div
        className="flex space-x-2 mt-2 overflow-x-auto "
        style={{
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          cursor: "ew-resize",
        }}
      >
        {fields.map((item, index) => (
          <span
            key={index}
            className="border border-red-600 text-red-600 rounded-full px-3 py-1 text-xs font-semibold whitespace-nowrap"
          >
            {transformFieldName(item)}
          </span>
        ))}
      </div>
    </div>
  );
};
/** @deprecated  */
export const HtmlRemarksContainer = ({ title, value }) => {
  const [remarks, setRemarks] = useState([]);
  const [detailsRemark, setDetailRemark] = useState("");
  const showRemarksInDetails = (remark) => {
    setDetailRemark(remark);
  };
  useEffect(() => {
    if (typeof value === "string") {
      const remarks = value?.split("||&&");
      setRemarks(remarks);
    } else if (Array.isArray(value)) {
      setRemarks(value);
    }
  }, [value]);
  return (
    <div>
      <ShowContentModal
        open={detailsRemark !== ""}
        close={() => {
          setDetailRemark("");
        }}
        width="auto"
        style={{ maxWidth: "400px" }}
        mask={true}
        element={
          <div>
            <p>{detailsRemark}</p>
          </div>
        }
      />
      {title && remarks?.length > 0 && (
        <h3 className="text-[13px] font-publicSans text-[#4B465C] mb-1 flex">{title}</h3>
      )}
      <div>
        {remarks?.map((remark, index) => {
          return (
            <div
              onClick={() => {
                showRemarksInDetails(remark);
              }}
              key={index}
              className="inline-block cursor-pointer text-sm font-publicSans text-[#4B465C] mr-2 my-2 ml-2 bg-gray-100 px-3 py-1 rounded-md border border-gray-300"
            >
              {remark.length > 15 ? remark.substring(0, 14) + "..." : remark}
            </div>
          );
        })}
      </div>
    </div>
  );
};
/** @deprecated  */
export const HtmlInput = ({
  oneTimeEditMode,
  allTimeEditMode,
  type,
  mandatory = false,
  required = false,
  placeholder,
  value,
  updatedValue,
  onChange = () => {},
  title,
  name,
  className,
  disabled = false,
  autoFocus,
  max,
  min,
}) => {
  const [access, setAccess] = useState(false);
  useEffect(() => {
    if (oneTimeEditMode) {
      setAccess(!fieldContainsValue(updatedValue));
    }
    if (allTimeEditMode) {
      setAccess(allTimeEditMode);
    }
    if (disabled) {
      setAccess(!disabled);
    }
  }, [oneTimeEditMode, disabled, value, updatedValue, allTimeEditMode]);
  return (
    <div>
      {title && (
        <h3 className="text-[13px] font-publicSans text-[#4B465C] mb-1 flex">
          {title} {mandatory && <SvgIcon size={10} type="star" />}
        </h3>
      )}
      <input
        min={min}
        max={max}
        autoFocus={autoFocus}
        type={type}
        name={name}
        className={`h-[42px] ${
          required ? "border-red-500" : ""
        } form-input p-1 w-full text-sm font-light text-gray-600 bg-transparent border border-gray-300 rounded-md focus:outline-none focus:ring-0 ${className}`}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={!access}
      ></input>
      {required && <p className="text-[13px] text-red-500">Required</p>}
    </div>
  );
};
/** @deprecated  */
export const HtmlCollapse = ({
  title,
  headerContent,
  element,
  open = false,
  titleProperties = {},
  closeIcon = true,
  containerStyle = {},
}) => {
  // State to manage whether the collapse is open or closed
  const [isOpen, setIsOpen] = useState(open);
  const contentRef = useRef(null);
  const [contentHeight, setContentHeight] = useState("0px");

  useEffect(() => {
    setIsOpen(open);
  }, [open]);
  // Function to toggle the collapse state
  const toggleCollapse = () => {
    setIsOpen(!isOpen);
  };
  useEffect(() => {
    if (isOpen) {
      // setContentHeight(`${contentRef.current.scrollHeight}px`);
      setContentHeight("auto");
    } else {
      setContentHeight("0px");
    }
  }, [isOpen]);

  return (
    <div style={containerStyle} id="html-collapse" className="shadow-lg rounded-lg">
      <div id="html-collapse-header" className="pl-5 pr-5 flex items-center justify-between py-4">
        <h5 className="text-[22px]" {...titleProperties}>
          {title}
        </h5>
        <div className="flex gap-5">
          {headerContent}
          {closeIcon && (
            <button
              onClick={toggleCollapse}
              style={{
                transform: isOpen ? "rotate(90deg)" : "rotate(0deg)",
                transition: "transform 0.4s ease",
                display: "block",
              }}
            >
              <SvgIcon size={25} type="right-arrow-point" />
              {/* open */}
            </button>
          )}
        </div>
      </div>
      <div
        ref={contentRef}
        style={{
          display: contentHeight === "auto" ? "block" : "none",
          height: contentHeight,
          overflow: "hidden",
          transition: "all 0.3s ease", // Smooth transition for height change
        }}
        className="px-5"
      >
        {element}
      </div>
    </div>
  );
};
/** @deprecated  */
export const ReactSelectNew = ({
  oneTimeEditMode,
  updatedValue,
  allTimeEditMode,
  placeholder,
  options = [],
  notFoundMessage,
  onChange = () => {},
  value,
  disabled,
  title,
  mandatory = false,
  required = false,
  className,
  hideClearIndicator = false,
}) => {
  const [access, setAccess] = useState(false);
  useEffect(() => {
    if (oneTimeEditMode) {
      setAccess(!fieldContainsValue(updatedValue));
    }
    if (allTimeEditMode) {
      setAccess(allTimeEditMode);
    }
    if (disabled) {
      setAccess(!disabled);
    }
  }, [oneTimeEditMode, disabled, value, updatedValue, allTimeEditMode]);
  // Options for the select dropdown
  // const options = [
  //   { value: '1', label: 'Option 1' },
  // ];

  // State to hold the selected option
  const [selectedOption, setSelectedOption] = useState(null);
  useEffect(() => {
    if (value) {
      setSelectedOption(options.find((option) => option.value === value) || null);
    } else {
      setSelectedOption(null);
    }
  }, [value, options]);
  // Handler for the select change event
  const handleChange = (selected) => {
    setSelectedOption(selected);
    onChange(selected);
  };
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: "#ccc",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#888",
      },
      borderRadius: "7px",
      paddingTop: "0px",
      height: "42px",
      color: "blue",
      display: "flex",
      alignItems: "center",
      backgroundColor: "",
      cursor: state.isDisabled ? "not-allowed" : "pointer",
      zIndex: 1,
      // cursor:'not-allowed'
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "5px",
      marginTop: "5px",
      zIndex: 1,
      // position:'absolute',
      // backgroundColor:"pink"
      //   backgroundColor:"pink"
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#f0f0f0" : "#fff",
      color: "#333",
      padding: "8px",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "#e0e0e0",
      },
      // backgroundColor:'green',
      //   backgroundColor:'green',
      fontSize: "15px",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#333",
      fontSize: "15px",
      //   backgroundColor:'red',
      lineHeight: "1", // Adjust line height to reduce space
      margin: "0", // Remove any default margin
      //   paddingBottom:"10px"
      //   margin:"auto"
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#999", // Change the color of the placeholder if needed
      fontSize: "15px", // Change the font size of the placeholder
    }),
    input: (provided) => ({
      ...provided,
      color: "#333", // Change the color of the input text
      fontSize: "15px", // Change the font size of the input text
      lineHeight: "1", // Adjust line height to reduce space
      margin: "0", // Remove any default margin
    }),
    noOptionsMessage: (provided) => ({
      ...provided,
      color: "#999", // Change the color of the no options message
      padding: "8px", // Add some padding
      textAlign: "center", // Center the text
      fontSize: "15px",
    }),
    clearIndicator: (provided) => ({
      ...provided,
      // color: 'red', // Change the color of the clear indicator
      // cursor: 'pointer',
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  const CustomClearIndicator = (props) => {
    return (
      <components.ClearIndicator {...props}>
        <span
          style={{
            fontSize: "13px",
            cursor: "pointer",
            color: "#333", // Set default color
            ":hover": {
              color: "#666", // Set hover color
            },
          }}
        >
          ✖
        </span>
      </components.ClearIndicator>
    );
  };

  const noOptionsMessage = () => (
    <div style={{ color: "#999", textAlign: "center" }}>
      {notFoundMessage ? notFoundMessage : "No options"}
    </div>
  );
  return (
    <div className={`${className}`}>
      {title && (
        <h3 className="text-[13px] font-publicSans text-[#4B465C] mb-1 flex">
          {title} {mandatory && <SvgIcon size={10} type="star" />}
        </h3>
      )}
      <Select
        menuPortalTarget={document.body}
        isDisabled={!access}
        styles={customStyles}
        value={selectedOption}
        onChange={handleChange}
        options={[...options]}
        placeholder={`Select ${placeholder ? placeholder : ""}`}
        isClearable={!updatedValue}
        noOptionsMessage={noOptionsMessage}
        components={
          hideClearIndicator
            ? { ClearIndicator: () => null } // hide "x" if prop is true
            : { ClearIndicator: CustomClearIndicator }
        }
      />
      {required && <p className="text-[13px] text-red-500">Required</p>}
    </div>
  );
};
/** @deprecated  */
export const HtmlMultiSelectWithTags = ({
  options = [],
  value = [],
  title = "",
  disabled = false,
  allTimeEditMode = true,
  onChange,
  assignedItems = [],
  onAssignedRemove,
  placeholder = "Select...",
  isSingleSelectMode = false,
  hideClearIndicator = false,
  viewOnly = false,
}) => {
  const [selected, setSelected] = useState([]);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    setSelected(value || []);
  }, [value]);

  const handleChange = (selectedOption) => {
    // if (!selectedOption) return;
    if (selectedOption === null) {
      setSelected([]);
      onChange && onChange([]);
      return;
    }
    const option = Array.isArray(selectedOption) ? selectedOption[0] : selectedOption;

    // Avoid duplicates
    if (selected.some((s) => s.value === option.value)) return;

    const newSelection = isSingleSelectMode ? [option] : [...selected, option];
    setSelected(newSelection);
    onChange && onChange(newSelection);

    setInputValue(""); // Clear select input
  };

  const handleTagRemove = (val) => {
    const newSelection = selected.filter((opt) => opt.value !== val);
    setSelected(newSelection);
    onChange && onChange(newSelection);
  };

  const filteredOptions = options.filter(
    (opt) =>
      !assignedItems.some((a) => a.id === opt.value) && !selected.some((s) => s.value === opt.value)
  );

  const isSelectDisabled = disabled || (isSingleSelectMode && selected.length >= 1);

  return (
    <>
      {/* {viewOnly && (
      <div className="absolute inset-0 bg-transparent z-10 cursor-not-allowed"> */}
      <div className="w-full">
        <ReactSelectNew
          className="w-full"
          // disabled={isSelectDisabled}
          disabled={viewOnly || isSelectDisabled}
          allTimeEditMode={allTimeEditMode}
          onChange={handleChange}
          options={filteredOptions}
          title={title}
          // value={null}
          value={isSingleSelectMode ? selected[0] || null : null}
          inputValue={inputValue}
          onInputChange={(val) => setInputValue(val)}
          isSearchable
          placeholder={placeholder}
          hideClearIndicator={hideClearIndicator}
        />

        {/* Selected Tags */}
        {selected.length > 0 && (
          <div className="flex flex-wrap gap-2 mt-2">
            {selected.map((tag) => (
              <span
                key={tag.value}
                className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm flex items-center gap-2"
              >
                {tag.label}
                {/* <button
                onClick={() => handleTagRemove(tag.value)}
                className="text-blue-500 hover:text-red-500 text-xs"
              >
                ✕
              </button> */}
                {!viewOnly && (
                  <button
                    onClick={() => handleTagRemove(tag.value)}
                    className="text-blue-500 hover:text-red-500 text-xs"
                  >
                    ✕
                  </button>
                )}
              </span>
            ))}
          </div>
        )}

        {/* Assigned Tags */}
        {assignedItems?.length > 0 && (
          <div className="mt-4">
            <p className="text-[13px] font-publicSans text-[#4B465C] mb-2">
              Assigned {title} ({assignedItems.length})
            </p>
            <div className="flex flex-wrap gap-2">
              {assignedItems.map((item) => (
                <span
                  key={item.id}
                  className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm flex items-center gap-2"
                >
                  {item.name}
                  {/* <button
                  onClick={() => onAssignedRemove && onAssignedRemove(item.id)}
                  className="text-blue-500 hover:text-red-500 text-xs"
                >
                  ✕
                </button> */}
                  {!viewOnly && (
                    <button
                      onClick={() => onAssignedRemove && onAssignedRemove(item.id)}
                      className="text-blue-500 hover:text-red-500 text-xs"
                    >
                      ✕
                    </button>
                  )}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>
      {/* </div>
    )} */}
    </>
  );
};
/** @deprecated  */
export const HtmlFileUploader = ({
  multiple = true,
  accept = "*",
  onChange = () => {},
  submitButton = false,
  notes = {},
  value,
}) => {
  const [files, setFiles] = useState([]);
  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFiles = Array.from(e.dataTransfer.files);
    handleFiles(droppedFiles);
  };
  useEffect(() => {
    if (!submitButton) {
      onChange(files);
    }
  }, [files]);
  useEffect(() => {
    if (Array.isArray(value) && value.length === 0) {
      setFiles(value);
    }
  }, [value]);

  const handleUpload = (e) => {
    const uploadedFiles = Array.from(e.target.files);
    handleFiles(uploadedFiles);
    e.target.value = null;
  };

  const handleFiles = (selectedFiles) => {
    const newFiles = multiple ? [...files, ...selectedFiles] : selectedFiles.slice(0, 1);
    setFiles(newFiles);
  };

  const preventDefault = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const getFriendlyAcceptTypes = () => {
    if (accept === "*") return "any file type";
    return accept
      .split(",")
      .map((type) =>
        type.trim().replace("image/*", "jpg, png, webp, jpeg").replace(".", "").toUpperCase()
      )
      .join(", ");
  };
  const handlePreviewFile = (file) => {
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL, "_blank");
  };
  const handleRemoveFile = (indexToRemove) => {
    setFiles((prev) => prev.filter((_, index) => index !== indexToRemove));
  };

  return (
    <div>
      <div className="file-uploader bg-red-500">
        <div
          className="fu-drop-zone "
          onDrop={handleDrop}
          onDragOver={preventDefault}
          onDragEnter={preventDefault}
          onDragLeave={preventDefault}
        >
          <p style={{ textAlign: "center" }} className="flex justify-center">
            <SvgIcon size={40} type={"upload"} />
          </p>
          <p>Drag & drop your files here or click to upload</p>
          <p>
            <span className="text-red-500">*</span>
            <span>File Supported </span> {getFriendlyAcceptTypes()}
          </p>

          <input
            type="file"
            multiple={multiple}
            accept={accept}
            onChange={handleUpload}
            className="fu-file-input"
          />
        </div>
        {/* <div className="fu-file-list">
        {files.map((file, index) => (
          <div key={index} className="fu-file-item">
            📄 {file.name}
          </div>
        ))}
      </div> */}
        <div id="extra-component">{notes}</div>
        {files?.length > 0 && (
          <div
            className="fu-file-list invisible-scrollbar"
            style={{ maxHeight: "200px", overflow: "scroll", border: "none" }}
          >
            {files.map((file, index) => (
              <div key={index} className="fu-file-item flex items-center justify-between">
                <span
                  className="fu-file-name"
                  onClick={() => handlePreviewFile(file)}
                  style={{
                    cursor: "pointer",
                    color: "blue",
                    textDecoration: "underline",
                  }}
                >
                  📄 {file.name}
                </span>
                <span
                  className="fu-file-remove"
                  onClick={() => handleRemoveFile(index)}
                  style={{
                    marginLeft: "10px",
                    color: "red",
                    cursor: "pointer",
                  }}
                >
                  <SvgIcon type={"close"} />
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
      {submitButton && (
        <HtmlButton
          disabled={files?.length <= 0}
          onClick={() => {
            onChange(files);
          }}
          className="mt-2"
          style={{ margin: "auto", marginTop: "10px" }}
          type={"primary"}
          outline={false}
          text="Continue"
        />
      )}
    </div>
  );
};
/** @deprecated  */
export const HtmlTooltip = ({ tip, type = "hover", children }) => {
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState("top");
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (type === "click" && wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [type]);

  const showTooltip = () => {
    if (wrapperRef.current) {
      const rect = wrapperRef.current.getBoundingClientRect();
      const spaceTop = rect.top;
      const spaceBottom = window.innerHeight - rect.bottom;
      const spaceLeft = rect.left;
      const spaceRight = window.innerWidth - rect.right;

      const maxSpace = Math.max(spaceTop, spaceBottom, spaceLeft, spaceRight);

      let pos = "top";
      if (maxSpace === spaceTop) pos = "top";
      else if (maxSpace === spaceBottom) pos = "bottom";
      else if (maxSpace === spaceLeft) pos = "left";
      else if (maxSpace === spaceRight) pos = "right";

      setPosition(pos);
      setVisible(true);
    }
  };

  const hideTooltip = () => {
    setVisible(false);
  };

  const handleClick = () => {
    if (type === "click") {
      if (!visible) showTooltip();
      else hideTooltip();
    }
  };

  const handleMouseEnter = () => {
    if (type === "hover") showTooltip();
  };

  const handleMouseLeave = () => {
    if (type === "hover") hideTooltip();
  };

  const positionClasses = {
    top: "bottom-full left-1/2 -translate-x-1/2 mb-2",
    bottom: "top-full left-1/2 -translate-x-1/2 mt-2",
    left: "right-full top-1/2 -translate-y-1/2 mr-2",
    right: "left-full top-1/2 -translate-y-1/2 ml-2",
  };

  return (
    <div
      ref={wrapperRef}
      className="relative inline-block"
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
      {visible && (
        <div
          className={`absolute z-50 transform ${positionClasses[position]} bg-gray-800 text-white text-sm px-2 py-1 rounded shadow-md whitespace-nowrap`}
        >
          {tip}
        </div>
      )}
    </div>
  );
};
/** @deprecated  */
export const HtmlYesNoRadioButtons = ({
  title = "Tyres",
  value = null,
  className,
  onChange = () => {},
  disabled,
  checkedTitle = "",
  uncheckedTitle = "",
  type = "text-buttons",
}) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const selectedButtonStyle = {
    backgroundColor: "rgb(1,117,255)",
    color: "white",
    borderColor: "rgb(1,117,255)",
  };
  const defaultButtonStyle = {
    paddingTop: "0px",
    paddingBottom: "0px",
    margin: "5px",
  };
  const [buttonStyle, setButtonStyle] = useState({ yes: {}, no: {} });
  const [yesButtonStyle, setYesButtonStyle] = useState({
    ...defaultButtonStyle,
  });
  const handleChange = (event) => {
    onChange(event.target.value);
  };
  useEffect(() => {
    if (value !== undefined) {
      if (value === "0") {
        setButtonStyle({ yes: {}, no: selectedButtonStyle });
      } else if (value === "1") {
        setButtonStyle({ yes: selectedButtonStyle, no: {} });
      } else {
        setButtonStyle({ yes: {}, no: {} });
      }
    }
  }, [value]);

  const handleButtons = (value) => {
    onChange(value);
  };
  return (
    <div className={`w-full px-1 ${className}`}>
      <div
        style={{
          borderBottom: "solid",
          borderBottomWidth: "1px",
          borderBottomColor: "rgb(205,209,215)",
        }}
        className="flex w-full justify-between text-[16px]"
      >
        <p style={{ fontSize: "16px", color: "#4B465C", fontWeight: "400" }}>{title}</p>
        {type === "default" && (
          <div className="flex gap-5">
            <label className="flex items-center gap-2">
              <input
                type="radio"
                value={"1"}
                checked={value === "1"}
                onChange={handleChange}
                disabled={disabled}
              />
              Yes
            </label>
            <label className="flex items-center gap-2">
              <input
                type="radio"
                value={"0"}
                checked={value === "0"}
                onChange={handleChange}
                disabled={disabled}
              />
              No
            </label>
          </div>
        )}
        {type === "text-buttons" && (
          <div className="flex gap-3">
            <HtmlButton
              onClick={() => {
                handleButtons("1");
              }}
              type={"dark"}
              outline={true}
              style={{ ...defaultButtonStyle, ...buttonStyle?.yes }}
              text={"Yes"}
            />
            <HtmlButton
              onClick={() => {
                handleButtons("0");
              }}
              type={"dark"}
              outline={true}
              style={{ ...defaultButtonStyle, ...buttonStyle?.no }}
              text={"No"}
            />
          </div>
        )}
      </div>
    </div>
    //     {/* <Switch    checked={selectedOption}  disabled={disabled} onChange={handleChange}  style={{
    //   backgroundColor: selectedOption ? 'rgb(10,226,106)' : 'rgb(251,57,58)',fontSize:"16px"
    // }} checkedChildren={checkedTitle} unCheckedChildren={uncheckedTitle} /> */}
  );
};
/** @deprecated  */
export const HtmlMultipleImageHandler = ({ className }) => {
  return (
    <div className={`w-full ${className}`}>
      <div className="">
        <p className="text-[16px]">Engine Compound (3 Pics)</p>
        <span>
          {" "}
          <SvgIcon size="25" type={"camera-icon"} />
        </span>
        <div className="flex gap-2">
          <img
            width={100}
            height={100}
            src="https://cdn.magicdecor.in/com/2024/05/14172331/Mayur-Vatika-Wallpaper-M4-710x488.jpg"
          />
          <img
            width={100}
            height={100}
            src="https://cdn.magicdecor.in/com/2024/05/14172331/Mayur-Vatika-Wallpaper-M4-710x488.jpg"
          />
          <img
            width={100}
            height={100}
            src="https://cdn.magicdecor.in/com/2024/05/14172331/Mayur-Vatika-Wallpaper-M4-710x488.jpg"
          />
        </div>
      </div>
      {/* <div className="w-full mt-2 h-[200px] bg-gray-100 border border-dashed border-gray-300 rounded-md"></div> */}
    </div>
  );
};
/** @deprecated  */
export const HtmlImageUploaderWithShow = ({
  title,
  className,
  value = [],
  jobData,
  uploadMethod,
  data,
  multiple,
  suffixTooltip,
  compulsory,
  onSelect,
  addMoreButton = true,
  maxSelect = null,
  addMore,
  onAddMore = () => {},
  note = () => {},
  addMoreButtonDisabled = false,
  documentModalTitles = [],
  inputFileType = "png,jpeg,jpg",
}) => {
  const [openCamera, setOpenCamera] = useState(null);
  const [savedImages, setSavedImages] = useState([]);
  const [imagePreview, setImagePreview] = useState("");

  // Update saved images when value (array) changes
  useEffect(() => {
    setSavedImages(value);
  }, [value]);

  const handleCamera = () => {
    setOpenCamera(true);
  };

  return (
    <div className={`w-full ${className}`}>
      <div>
        {getDataType(title) === "string" && (
          <p
            style={{
              marginBottom: "1.1%",
              fontSize: "16px",
              fontWeight: "400",
              color: "#4B465C",
            }}
          >
            {title}
            {suffixTooltip && (
              <HtmlTooltip tip={suffixTooltip?.tip}>
                <span style={{ marginLeft: "5px", cursor: "help" }}> {suffixTooltip?.text}</span>
              </HtmlTooltip>
            )}
            {compulsory && <span style={{ color: "red" }}>*</span>}
          </p>
        )}
        {getDataType(title) !== "string" && title}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "start",
          }}
        >
          <HtmlDocumentModal
            labels={documentModalTitles}
            download={true}
            onClose={() => {
              setImagePreview("");
            }}
            imageValue={imagePreview?.value}
            activeIndex={imagePreview?.index}
            addMore={addMore}
            onAddMore={(activeIndex) => {
              if (onAddMore) {
                onAddMore(activeIndex);
              }
            }}
            addMoreText={"Re Upload"}
          />
          <DocumentUploadHandler
            maxSelect={maxSelect}
            afterUpload={() => {
              setOpenCamera(null);
            }}
            data={data}
            uploadMethod={uploadMethod}
            onSelect={(e) => {
              setOpenCamera(null);
              onSelect(e);
            }}
            jobData={jobData}
            onCameraClose={() => {
              setOpenCamera(null);
            }}
            camera={openCamera ? openCamera : false}
            buttons={false}
            multiple={multiple}
            note={note}
            inputFileType={inputFileType}
          />
          <div style={{ overflowX: "scroll" }} className="flex gap-2 invisible-scrollbar">
            {Array.isArray(savedImages) &&
              savedImages.length > 0 &&
              savedImages.map((item, index) => (
                <div style={{ position: "relative" }}>
                  {" "}
                  <img
                    key={index}
                    width={100}
                    height={70}
                    src={item}
                    style={{ width: "64px", height: "70px" }}
                    className="cursor-pointer"
                    alt=""
                    onClick={() => {
                      setImagePreview({
                        index: index,
                        value: savedImages,
                        title: documentModalTitles[index],
                      });
                    }}
                  />
                  {item?.includes("//s3-carrum") && (
                    <span
                      style={{ width: "15px", height: "15px", borderRadius: "50%" }}
                      className="absolute top-1 right-1 bg-green-500 text-[10px] flex items-center justify-center"
                    >
                      ✔
                    </span>
                  )}
                  {!item?.includes("s3") && item !== null && (
                    <span
                      style={{
                        opacity: 0.8,
                      }}
                      className="absolute top-0 right-0 text-[10px] flex items-center justify-center w-full h-full bg-gray-50"
                    >
                      {/* UPLOADING */}
                      <SvgIcon size="22" type="uploading-icon-animation" />
                    </span>
                  )}
                  {item === null && (
                    <span
                      style={{
                        opacity: 0.8,
                        borderWidth: "0.3px",
                      }}
                      className="absolute top-0 right-0 text-[10px] flex  flex-col items-center justify-center w-full h-full bg-gray-50 text-blue-700 border border-blue-700 "
                    >
                      <SvgIcon size="22" type="devices-group" />
                      Uploading
                    </span>
                  )}
                </div>
              ))}
          </div>
          {addMoreButton && (
            <button
              className="ml-2"
              onClick={handleCamera}
              disabled={addMoreButtonDisabled}
              style={{
                border: "dashed",
                width: "64px",
                minWidth: "61px",
                minHeight: "64px",
                borderColor: "rgb(126,126,126)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "rgb(67,25,255)",
                borderRadius: "4px",
                ...(addMoreButtonDisabled && {
                  cursor: "not-allowed",
                  color: "rgb(126,126,126)",
                }),
              }}
            >
              <SvgIcon size="32" type={"plus"} />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
/** @deprecated  */
export const HtmlMultipleImageUploaderWithShow = ({
  title,
  className,
  value = [],
  jobData,
  uniqueId,
  uploadMethod,
  data,
  multiple,
  suffixTooltip,
  compulsory,
  onSelect,
  onUpload,
  addMoreButton = true,
  maxSelect = null,
  docType,
  addMore,
  onAddMore = () => {},
  note = () => {},
  addMoreButtonDisabled = false,
  documentModalTitles = [],
  inputFileType = "png,jpeg,jpg,pdf",
  onImageAttributeChange = () => {},
  onRemarksChange = () => {},
  isRemarks = false,
  individualRemarks = false,
  individualInput = true,
}) => {
  const [openCamera, setOpenCamera] = useState(false);
  const [savedImages, setSavedImages] = useState([]);
  const [imagePreview, setImagePreview] = useState("");
  const [imageAttributeObj, setimageAttributeObj] = useState({});
  const [remarkAttributeObj, setremarkAttributeObj] = useState({});
  const [remarks, setRemarks] = useState("");

  // Update saved images when value (array) changes
  useEffect(() => {
    // const normalizedImages = Array.isArray(value) ? value.filter(Boolean) : [];
    setSavedImages(value);
  }, [value]);

  // Memoize cleaned attributes to avoid recalculating
  const cleanedImageAttrs = useMemo(
    () => removeEmptyValuesFromObject(imageAttributeObj || {}),
    [imageAttributeObj]
  );
  const cleanedRemarkAttrs = useMemo(
    () => removeEmptyValuesFromObject(remarkAttributeObj || {}),
    [remarkAttributeObj]
  );

  // Memoize callback object to prevent unnecessary parent re-renders
  useEffect(() => {
    onImageAttributeChange({
      imageAttribute: cleanedImageAttrs,
      remarkAttribute: cleanedRemarkAttrs,
      images: savedImages,
      isSubmitDisabled: Object.keys(cleanedImageAttrs).length !== savedImages.length,
    });
  }, [cleanedImageAttrs, cleanedRemarkAttrs, savedImages, onImageAttributeChange]);

  // Memoized handlers to prevent child re-renders
  const handleCamera = useCallback(() => setOpenCamera(true), []);
  const handleCloseCamera = useCallback(() => setOpenCamera(false), []);
  const handleClosePreview = useCallback(() => setImagePreview(""), []);

  const handleImageSelect = useCallback(
    (e) => {
      setOpenCamera(false);
      const arr = [...e].reverse();
      onSelect(arr);
    },
    [onSelect]
  );

  const handleImageAttributeChange = useCallback((e) => {
    const { name, value: val } = e.target;
    setimageAttributeObj((prev) => ({
      ...prev,
      [name]: val?.toUpperCase(),
    }));
  }, []);

  const handleRemarkAttributeChange = useCallback((e) => {
    const { name, value: val } = e.target;
    setremarkAttributeObj((prev) => ({
      ...prev,
      [name]: val,
    }));
  }, []);

  const handleRemarksChange = useCallback(
    (e) => {
      const val = e.target.value;
      setRemarks(val);
      onRemarksChange(val);
    },
    [onRemarksChange]
  );

  const handleAddMore = useCallback(
    (activeIndex) => {
      onAddMore(activeIndex);
    },
    [onAddMore]
  );
  const titleStyle = useMemo(
    () => ({
      marginBottom: "1.1%",
      fontSize: "16px",
      fontWeight: "400",
      color: "#4B465C",
    }),
    []
  );

  const containerStyle = useMemo(
    () => ({
      display: "flex",
      alignItems: "center",
      justifyContent: "start",
    }),
    []
  );

  const addButtonStyle = useMemo(
    () => ({
      border: "dashed",
      width: "auto",
      minWidth: "100px",
      minHeight: "100px",
      borderColor: "rgb(126,126,126)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: "rgb(67,25,255)",
      borderRadius: "4px",
      ...(addMoreButtonDisabled && {
        cursor: "not-allowed",
        color: "rgb(126,126,126)",
      }),
    }),
    [addMoreButtonDisabled]
  );

  return (
    <div className={`w-full ${className}`}>
      <div>
        {getDataType(title) === "string" ? (
          <p style={titleStyle}>
            {title}
            {suffixTooltip && (
              <HtmlTooltip tip={suffixTooltip?.tip}>
                <span style={{ marginLeft: "5px", cursor: "help" }}>{suffixTooltip?.text}</span>
              </HtmlTooltip>
            )}
            {compulsory && <span style={{ color: "red" }}>*</span>}
          </p>
        ) : (
          title
        )}
        <div style={containerStyle}>
          <HtmlDocumentModal
            labels={documentModalTitles}
            download={true}
            onClose={handleClosePreview}
            imageValue={imagePreview?.value}
            activeIndex={imagePreview?.index}
            addMore={addMore}
            onAddMore={handleAddMore}
            addMoreText="Re Upload"
          />
          <DocumentUploadHandler
            maxSelect={maxSelect}
            afterUpload={handleCloseCamera}
            data={data}
            uploadMethod={uploadMethod}
            onSelect={handleImageSelect}
            jobData={jobData}
            onCameraClose={handleCloseCamera}
            camera={openCamera}
            buttons={false}
            multiple={multiple}
            note={note}
            inputFileType={inputFileType}
          />
          <div style={{ overflowX: "scroll" }} className="flex gap-2 invisible-scrollbar">
            <div>
              <div className="grid grid-cols-1 gap-5">
                {savedImages.length > 0 &&
                  savedImages.map((item, index) => (
                    <div
                      key={`image-${index}-${item}`}
                      className="flex flex-col bg-gradient-to-br from-white via-[#f9f9ff] to-[#eef2ff] border border-gray-200 rounded-[5px] shadow-md transition-all duration-300 overflow-hidden"
                    >
                      <div className="relative group bg-white overflow-hidden">
                        <div className="flex flex-col border-r border-gray-200 pr-4 w-[500px] h-[500px]">
                          <DocumentViewerControls billUrl={item} />
                        </div>
                      </div>
                      {individualInput && (
                        <div className="p-3 border-t border-gray-200 flex flex-col justify-center bg-[#f2f2f2]">
                          <Input
                            type="text"
                            name={`image_${index + 1}`}
                            value={imageAttributeObj[`image_${index + 1}`] || ""}
                            onChange={handleImageAttributeChange}
                            placeholder="Enter Bill Number*"
                            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-400 transition-all duration-200"
                          />
                        </div>
                      )}
                      {individualRemarks && (
                        <div className="p-3 border-t border-gray-200 flex flex-col justify-center bg-[#f2f2f2]">
                          <Input
                            type="text"
                            name={`remark_${index + 1}`}
                            value={remarkAttributeObj[`remark_${index + 1}`] || ""}
                            onChange={handleRemarkAttributeChange}
                            placeholder="Enter Remarks"
                            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-400 transition-all duration-200"
                          />
                        </div>
                      )}
                    </div>
                  ))}
                {addMoreButton && (
                  <div className="flex justify-center items-center bg-gradient-to-br from-[#f8faff] via-[#f4f6ff] to-[#edf0ff] rounded-xl">
                    <button
                      className="w-[100px] h-[100px] my-4 mx-4"
                      onClick={handleCamera}
                      disabled={addMoreButtonDisabled}
                      style={addButtonStyle}
                    >
                      <SvgIcon size="54" type="plus" />
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {isRemarks && (
          <div className="w-full mt-6">
            <h1 className="text-[13px] font-publicSans text-[#4B465C] flex">Remarks</h1>
            <div className="w-full mt-1">
              <HtmlTextArea
                type="text"
                value={remarks}
                onChange={handleRemarksChange}
                placeholder="Enter Remarks"
                className="w-full"
                rows={3}
                allTimeEditMode={true}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
/** @deprecated  */
export const ExpandableTextModal = ({
  text = "",
  length = 24,
  title = "Reason",
  openLength = 1,
  type = "default", // New prop to control styling type
  textBeautify = false,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Parse if it's a JSON string that looks like an array
  let parsedText = text;
  try {
    if (typeof text === "string" && text?.trim()?.startsWith("[") && text?.trim()?.endsWith("]")) {
      parsedText = JSON?.parse(text);
    }
  } catch (err) {
    // If parsing fails, keep original text
  }

  const isArray = Array.isArray(parsedText);
  const arr = isArray ? parsedText : [];

  // Handle display preview
  const previewText = isArray
    ? arr?.slice(0, 2)?.join(", ") + (arr?.length > openLength ? "..." : "")
    : text?.length > length
      ? text?.slice(0, length) + "..."
      : text;

  const isLong = isArray ? arr?.length > openLength : text?.length > length;

  if (!text && arr?.length === 0) return null;

  return (
    <>
      <span
        onClick={() => isLong && setIsModalOpen(true)}
        style={{
          cursor: isLong ? "pointer" : "default",
          display: "inline-block",
          whiteSpace: "nowrap",
          overflow: isLong ? "hidden" : "visible",
          textOverflow: isLong ? "ellipsis" : "clip",
          maxWidth: "100%",
        }}
        className={`${
          type === "in-form"
            ? "w-full border-[1px] bg-white border-[#dfdfdf] h-[38px] text-[15px] px-[11px] rounded-[6px] focus:outline-none input-value-dm-400 flex items-center justify-center pt-[6px]"
            : ""
        }`}
        title={isLong ? (isArray ? arr?.join(", ") : text) : ""}
      >
        {textBeautify ? textBeautifyFunction(previewText) : previewText}
      </span>

      <Modal open={isModalOpen} onCancel={() => setIsModalOpen(false)} footer={null} title={title}>
        {isArray ? (
          arr?.length > 0 ? (
            <ol style={{ paddingLeft: "20px" }}>
              {arr?.map((item, index) => (
                <li key={index} style={{ marginBottom: "5px", whiteSpace: "pre-wrap" }}>
                  {textBeautify ? textBeautifyFunction(item) : item}
                </li>
              ))}
            </ol>
          ) : (
            "---"
          )
        ) : (
          <div style={{ whiteSpace: "pre-wrap" }}>
            {text ? (textBeautify ? textBeautifyFunction(text) : text) : "---"}
          </div>
        )}
      </Modal>
    </>
  );
};
/** @deprecated  */
export const NewButton = ({
  onClick,
  disabled = false,
  showOpacity = false,
  className = "",
  maxWidth = "200px",
  svgIconType = null,
  text = "",
  key,
  infoHide = true,
  infoMessage = "",
  mainClassName = "",
  disabledMessage = "",
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div
      className={`${mainClassName} relative`}
      onMouseEnter={() => {
        if (disabled && disabledMessage) {
          setShowTooltip(true);
        }
      }}
      onMouseLeave={() => {
        setShowTooltip(false);
      }}
    >
      <button
        key={key}
        type="button"
        className={`relative mt-[2px] font-dm-sans-nocolor-500 text-nowrap w-full h-[42px] text-[15px] leading-[18px] tracking-[0.43px] rounded-[16px] border border-transparent bg-white z-0 max-w-[190px] ${className} ${
          disabled ? "opacity-60" : ""
        }`}
        style={{
          backgroundImage:
            "linear-gradient(white, white), linear-gradient(135deg, #868CFF 0%, #4318FF 100%)",
          backgroundOrigin: "border-box",
          backgroundClip: "padding-box, border-box",
          maxWidth: maxWidth,
        }}
        onClick={onClick}
        disabled={disabled}
      >
        <div className="px-[16px] py-[9px] -mt-[1px] flex justify-start items-center text-[#2F2F2F] text-[15px] leading-[18px] font-dm-sans-nocolor-500">
          {svgIconType && <FigmaSvgIcon type={svgIconType} size="15px" />}
          <span className="ml-[12px]">{text}</span>
        </div>
      </button>

      {/* Tooltip */}
      <TooltipPopup
        show={showTooltip && disabled && disabledMessage}
        message={disabledMessage}
        position="top"
        maxWidth="200px"
      />
    </div>
  );
};
/** @deprecated  */
export const HistoryButton = ({ ref, onClick = () => {}, text = "", disabled = false }) => {
  return (
    <button
      ref={ref}
      onClick={onClick}
      disabled={disabled}
      style={{ letterSpacing: "0.43px" }}
      className={`rounded-[16px] border text-nowrap border-[#616161] !text-[#616161] leading-[16px] text-[13px] font-dm-sans-nocolor-500 py-[6px] px-[14px] w-full z-100 ${
        disabled ? "cursor-not-allowed" : ""
      }`}
    >
      <div className="flex items-center gap-x-[6px] -ml-[2px]">
        <FigmaSvgIcon type="request-clock" size="13px" />
        {text}
      </div>
    </button>
  );
};
/** @deprecated  */
export const NewSelect = ({
  name = "",
  value = "",
  onChange = () => {},
  disabled = false,
  className = "",
  children,
  id,
  index,
  fallBackValue = "",
  showSelect = true,
  defaultValue,
  //when you want to add relative position on parent of your choice than you have to make this "wantParentZIndex" variable true and add relative position in parents
  wantParentZIndex = false,
  dropdown_height = "default", // New prop to control dropdown height
}) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleClickOutside = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleOptionClick = (optionValue) => {
    // onChange({ target: { name: name, value: optionValue } });
    onChange({
      target: {
        name: name,
        value: optionValue,
        id: id,
        index: index,
      },
    });
    setOpen(false);
  };

  const getSelectedLabel = () => {
    const selectedChild = React.Children.toArray(children).find(
      (child) => React.isValidElement(child) && child.props.value === value
    );
    return selectedChild
      ? capitalizeFirstLetterEachWord(selectedChild?.props?.children)
      : // : "Select";
        value && fallBackValue
        ? fallBackValue
        : "Select";
  };

  return (
    <div className="-mt-[1px]" id={id} index={index}>
      {" "}
      <div
        ref={dropdownRef}
        className={`${wantParentZIndex ? wantParentZIndex : "relative"} inline-block w-full `}
      >
        {/* Dropdown Button */}
        <div
          className={`${
            disabled
              ? "border-[#dfdfdf] pointer-events-none input-value-dm-400"
              : "hover:!border-[#4B465C] border-[#dfdfdf] input-value-dm-400"
          } flex justify-between items-center cursor-pointer border-[1px] rounded-[6px] px-[10px] h-[38px] text-[15px] ${className}`}
          onClick={() => !disabled && setOpen((prev) => !prev)}
        >
          <span
            className={`block max-w-full truncate pr-3 ${
              getSelectedLabel() === "Select" ? "!text-[#aaaaaa]" : ""
            }`}
            title={getSelectedLabel()} // optional: shows full text on hover
          >
            {getSelectedLabel()}
          </span>

          <FigmaSvgIcon type="dropdown-icon" />
        </div>

        {/* Dropdown Menu */}
        {open && (
          <div
            className={`absolute z-10 mt-1 w-full bg-white border border-[#c9c9c9] rounded-[6px] shadow-lg overflow-hidden overflow-y-auto ${
              dropdown_height === "default" ? "max-h-[200px]" : `max-h-[${dropdown_height}px]`
            }`}
          >
            {/* Clear Option */}
            {showSelect && (
              <div
                key="remove"
                // onClick={() => handleOptionClick("remove")}
                onClick={() => handleOptionClick("")}
                className={`cursor-pointer px-[10px] py-2 text-[#616161] font-dm-sans-400 text-[15px] hover:bg-[#e9e9e9] ${
                  value === "" ? "bg-gray-100 font-bold" : ""
                }`}
              >
                Unselect
              </div>
            )}

            {/* Actual Options */}
            {React.Children.map(children, (child, index) => {
              if (!React.isValidElement(child)) return null;
              const isDisabled = child.props.disabled;
              const isSelected = child.props.value === value;

              return (
                <div
                  key={index}
                  onClick={() => !isDisabled && handleOptionClick(child.props.value)}
                  className={`cursor-pointer px-[10px] py-2 font-dm-sans-nocolor-400 text-[15px] ${
                    isSelected ? "bg-gray-100 font-bold" : ""
                  } ${
                    isDisabled || child.props.disabled
                      ? "!text-[#aaaaaa] pointer-events-none"
                      : "text-[#616161] hover:bg-[#e9e9e9]"
                  }`}
                >
                  {capitalizeFirstLetterEachWord(child.props.children)}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};
/** @deprecated  */
export const MissingRequiredFieldShow = ({ missingFields, specialChar = {}, label = true }) => {
  return (
    Array.isArray(missingFields) &&
    missingFields?.length > 0 && (
      <div className="px-[4px] rounded-md max-w-full mt-6">
        {label && (
          <span className="block text-[13px] font-medium text-red-600 mb-1">Missing Fields:</span>
        )}
        <div className="flex flex-row gap-2 overflow-y-auto max-h-40 invisible-scrollbar">
          {missingFields?.map((item, index) => {
            return (
              <div
                key={index}
                className="text-[15px] font-dm-sans-nocolor-400 text-red-600 border border-red-300 rounded-full px-[13px] py-[2px] bg-white text-nowrap"
              >
                {specialChar[item] ? specialChar[item] : textBeautifyFunction(item)}
              </div>
            );
          })}
          {!missingFields ||
            (missingFields?.length === 0 && (
              <span className="text-[14px] text-gray-500">
                {" "}
                There are no remaining fields to be filled
              </span>
            ))}
        </div>
      </div>
    )
  );
};
/** @deprecated  */
export const MultiSelect = ({
  value,
  onChange,
  options,
  placeholder,
  isDisabled,
  isError = false,
}) => {
  const hasValue = Array.isArray(value) && value.length > 0;

  const CustomClearIndicator = (props) => {
    const hasValue = props.hasValue;
    if (!hasValue) return null;
    return null; // keep ✖ clear all button hidden
  };

  const CustomDropdownIndicator = (props) => {
    const hasValue = props.selectProps.hasValue;
    if (hasValue) return null;
    return (
      <components.DropdownIndicator {...props}>
        <FigmaSvgIcon type="dropdown-icon" />
      </components.DropdownIndicator>
    );
  };

  const CustomMultiValueRemove = (props) => {
    if (props.data?.isDisabled) return null;
    return <components.MultiValueRemove {...props} />;
  };

  return (
    <div className="relative inline-block w-full">
      <Select
        isMulti={true}
        name="custom-multi-select"
        value={value}
        onChange={onChange}
        options={options}
        placeholder={placeholder}
        isDisabled={isDisabled}
        components={{
          ClearIndicator: (props) => <CustomClearIndicator {...props} hasValue={hasValue} />,
          DropdownIndicator: (props) => <CustomDropdownIndicator {...props} hasValue={hasValue} />,
          MultiValueRemove: CustomMultiValueRemove,
          IndicatorSeparator: null,
        }}
        // className="w-full text-[15px] rounded-[6px] h-[38px] text-[#616161] font-dm-sans-nocolor-400"
        className="w-full text-[15px] rounded-[6px] text-[#616161] font-dm-sans-nocolor-400"
        classNamePrefix="tailwind"
        styles={{
          control: (base, state) => ({
            ...base,
            fontFamily: "DM Sans, sans-serif",
            fontWeight: 400,
            fontSize: "13px",
            lineHeight: "14px",
            paddingTop: "1px",
            paddingBottom: "1px",
            borderRadius: "6px",
            borderWidth: "1px",
            borderColor: isError ? "#ef4444" : state.isFocused ? "#4B465C" : "#dfdfdf",
            backgroundColor: "white",
            boxShadow: "none",
            "&:hover": {
              borderColor: isError ? "#ef4444" : "#4B465C",
              opacity: isError ? 1 : 0.8,
            },
          }),
          valueContainer: (base) => ({
            ...base,
            flexWrap: "wrap",
            gap: "6px",
            fontFamily: "DM Sans, sans-serif",
            fontWeight: 400,
            fontSize: "15px",
            lineHeight: "14px",
          }),
          multiValue: (base, { data }) => ({
            ...base,
            background: "linear-gradient(135deg, #868CFF 0%, #4318FF 100%)",
            opacity: data.isDisabled ? 0.8 : 1,
            borderRadius: "8px",
            paddingLeft: "2px",
            paddingRight: "2px",
            fontFamily: "DM Sans, sans-serif",
            fontWeight: 400,
            fontSize: "14px",
            paddingTop: "3px",
            paddingBottom: "3px",
          }),
          multiValueLabel: (base) => ({
            ...base,
            color: "white",
            fontWeight: 400,
            fontSize: "14px",
          }),
          multiValueRemove: (base, { data }) => ({
            ...base,
            display: data.isDisabled ? "none" : "flex",
            color: "white",
            ":hover": {
              backgroundColor: "#4B465C",
              color: "white",
            },
          }),
          placeholder: (provided) => ({
            ...provided,
            color: "#aaaaaa",
            fontSize: "15px",
            fontFamily: "'DM Sans', sans-serif",
            fontWeight: 400,
            lineHeight: "24px",
            opacity: 0.8,
            paddingLeft: "2.8px",
          }),
          input: (provided) => ({
            ...provided,
            color: "#4B465C",
            fontSize: "15px",
            lineHeight: "24px",
            paddingLeft: "2.8px",
          }),
        }}
      />
    </div>
  );
};
/** @deprecated  */
export const IncrementDecrement = ({
  value = 0,
  onChange = () => {},
  disabled = false,
  min = 0,
}) => {
  const handleDecrement = () => {
    const count = parseInt(value || 0);
    if (count > min) {
      onChange(count - 1);
    } else {
      onChange(min);
    }
  };

  const handleIncrement = () => {
    const count = parseInt(value || 0);
    onChange(count + 1);
  };

  const handleInput = (e) => {
    onChange(Number(e.target.value));
  };

  //
  return (
    <div
      className={`flex items-center rounded-[6px] border-[1px] mt-[2px] ${
        disabled
          ? "border-[#dedede] hover:border-[#dedede]"
          : "border-[#dedede] hover:border-[#000000]"
      }`}
    >
      <div>
        <button
          type="button"
          disabled={disabled}
          onClick={handleDecrement}
          className={` px-2 h-[38px] text-lg font-semibold transition-colors duration-150 ${
            disabled
              ? "text-[#AAAAAA] font-dm-sans-nocolor-400"
              : "text-[#616161] hover:text-[#616161]"
          }`}
        >
          −
        </button>
      </div>

      <div>
        {" "}
        <Input
          type=""
          min={min}
          // disabled={disabled}
          value={value}
          onChange={handleInput}
          style={{
            border: "none",
            outline: "none",
            // width: "70px",
            textAlign: "center",
            boxShadow: "none",
            pointerEvents: disabled ? "none" : "auto",
          }}
          className="h-[38px] text-[16px] px-auto font-semibold transition-colors duration-150 input-value-dm-400 !bg-[#ffffff]"
          // disabled={true}
        />
      </div>

      <div>
        {" "}
        <button
          type="button"
          disabled={disabled}
          onClick={handleIncrement}
          className={`px-2 h-[38px] text-lg font-semibold transition-colors duration-150 ${
            disabled ? "text-[#AAAAAA]" : "text-[#4B465C] hover:text-[#4B465C]"
          }`}
        >
          +
        </button>
      </div>
    </div>
  );
};
/** @deprecated  */
export const SaveButton = ({
  onClick = () => {},
  className,
  disabled = false,
  text,
  type = "submit",
}) => {
  let newClass = "";

  if (type?.toLowerCase() === "discard") {
    newClass = `${className} ${
      disabled ? "opacity-60 hover:opacity-60" : "opacity-80 hover:opacity-95"
    }  text-[#212121] text-[12px] md:text-[16px] font-dm-sans-save-500 text-[#333] border-[#ccc] bg-[#e2e6ea] rounded-[24px]`;
  } else {
    newClass = `${className} ${
      disabled ? "opacity-60 hover:opacity-60" : "hover:opacity-95"
    }  text-white text-[12px] md:text-[16px] font-dm-sans-save-500 bg-[linear-gradient(135deg,_#868CFF_0%,_#4318FF_100%)] rounded-[24px]`;
  }
  return (
    <button className={newClass} disabled={disabled} onClick={onClick}>
      {text}
    </button>
  );
};
/** @deprecated  */
export const CSVMenu = ({ text = "Choose CSV", options = [], className }) => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef();

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative inline-block text-left" ref={menuRef}>
      <button
        onClick={() => setOpen((prev) => !prev)}
        className={`${className} text-[13px] md:text-[15px] border-[1px] border-[#dfdfdf] hover:bg-[#f3f3f3] ${
          open ? "bg-[#f3f3f3]" : "bg-[#ffffff]"
        } text-[#616161] rounded-[24px] px-4 py-[4px] flex items-center space-x-2 transition duration-200 ease-in-out`}
      >
        <span>{text}</span>
        {/* <FigmaSvgIcon type="dropdown" /> */}
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-[170px] rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50 animate-fade-in">
          <ul className="py-1 text-[14px] text-gray-700">
            {options?.map((opt, idx) => (
              <li key={idx}>
                <button
                  className=" w-full text-left px-4 py-[6px] flex justify-start items-center gap-1 only-font-style hover:bg-gray-100 transition-colors"
                  onClick={() => {
                    opt?.onClick();
                    setOpen(false);
                  }}
                >
                  {opt?.name}{" "}
                  <div className="-mt-[4px]">
                    <SvgIcon
                      type="download"
                      className="only-font-style"
                      size="13px"
                      color="#616161"
                    />
                  </div>
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
/** @deprecated  */
export const EllipsisText = ({ text, partial = true, underline = false }) => {
  const textRef = useRef(null);
  const [isOverflowed, setIsOverflowed] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      setIsOverflowed(el.scrollWidth > el.clientWidth);
    }
  }, [text]);

  const textStyle = {
    display: "inline-block",
    maxWidth: "90%",
    width: "90%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    verticalAlign: "middle",
    cursor: "pointer",
    textDecoration: underline ? "underline" : "none",
  };
  const tooltipStyle = {
    maxHeight: "300px", // ✅ Limit height
    overflowY: "auto", // ✅ Enable scrolling if text exceeds height
    whiteSpace: "normal", // ✅ Allow wrapping inside tooltip
  };

  let textDiv = (
    <div ref={textRef} style={textStyle}>
      {text}
    </div>
  );
  if (isOverflowed) {
    textDiv = (
      <Tooltip title={text} overlayInnerStyle={tooltipStyle}>
        {textDiv}
      </Tooltip>
    );
  }

  return !partial ? (
    <Tooltip title={text} overlayInnerStyle={tooltipStyle}>
      <div
        style={{
          display: "inline-block",
          whiteSpace: "nowrap",
          maxWidth: "90%",
          width: "100%",
          overflow: "hidden",
          textOverflow: "ellipsis",
          verticalAlign: "middle",
          cursor: "default",
        }}
      >
        {text}
      </div>
    </Tooltip>
  ) : (
    textDiv
  );
};

//IT specially handle that type of select tag which has value as uuid, when the selected uuid not match with the records in Used Options Array than fallback value will shows, fallbackValue is the string it shows when uuid not matched with any options record, it primarly used in Product Type in OnboardingBA.js
/** @deprecated  */
export const NewSelect2 = ({
  name = "",
  value = "",
  onChange = () => {},
  disabled = false,
  className = "",
  children,
  id,
  index,
  fallBackValue = "",
  dropdownClass = "",
}) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleClickOutside = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleOptionClick = (optionValue) => {
    // onChange({ target: { name: name, value: optionValue } });
    onChange({
      target: {
        name: name,
        value: optionValue,
        id: id,
        index: index,
      },
    });
    setOpen(false);
  };

  const getSelectedLabel = () => {
    const selectedChild = React.Children.toArray(children).find(
      (child) => React.isValidElement(child) && child.props.value === value
    );
    return selectedChild
      ? capitalizeFirstLetterEachWord(selectedChild?.props?.children)
      : // : "Select";
        value && fallBackValue
        ? fallBackValue
        : "Select";
  };

  return (
    <div className="-mt-[1px]" id={id} index={index}>
      {" "}
      <div ref={dropdownRef} className={`relative inline-block w-full `}>
        {/* Dropdown Button */}
        <div
          className={`${
            disabled
              ? "border-[#dfdfdf] pointer-events-none input-value-dm-400"
              : "hover:!border-[#4B465C] border-[#dfdfdf] input-value-dm-400"
          } flex justify-between items-center cursor-pointer border-[1px] rounded-[6px] px-[10px] h-[38px] text-[15px] ${className}`}
          onClick={() => !disabled && setOpen((prev) => !prev)}
        >
          <span className={`${getSelectedLabel() === "Select" ? "!text-[#aaaaaa]" : ""}`}>
            {getSelectedLabel()}
          </span>
          <FigmaSvgIcon type="dropdown-icon" />
        </div>

        {/* Dropdown Menu */}
        {open && (
          <div className="absolute z-10 mt-1 w-full bg-white border border-[#c9c9c9] rounded-[6px] shadow-lg overflow-hidden max-h-[200px] overflow-y-auto">
            {/* Clear Option */}
            <div
              key="remove"
              // onClick={() => handleOptionClick("remove")}
              onClick={() => handleOptionClick("")}
              className={`cursor-pointer px-[10px] py-2 text-[#616161] font-dm-sans-400 text-[15px] hover:bg-[#e9e9e9] ${
                value === "" ? "bg-gray-100 font-bold" : ""
              }`}
            >
              Select
            </div>

            {/* Actual Options */}
            {React.Children.map(children, (child, index) => {
              if (!React.isValidElement(child)) return null;
              const isDisabled = child.props.disabled;
              const isSelected = child.props.value === value;

              return (
                <div
                  key={index}
                  onClick={() => !isDisabled && handleOptionClick(child.props.value)}
                  className={`cursor-pointer px-[10px] py-2 font-dm-sans-nocolor-400 text-[15px] ${
                    isSelected ? "bg-gray-100 font-bold" : ""
                  } ${
                    isDisabled || child.props.disabled
                      ? "!text-[#aaaaaa] pointer-events-none"
                      : "text-[#616161] hover:bg-[#e9e9e9]"
                  }`}
                >
                  {capitalizeFirstLetterEachWord(child.props.children)}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};
/** @deprecated  */
export const HubFilter = ({
  buttonLabel = "Select Hub",
  onSelect = () => {},
  disabled = false,
  showArrow = true,
  value = null,
  allOption = true,
  excludeOption = [],
}) => {
  const [options, setOptions] = useState([]);
  const handleMenuClick = ({ key }) => {
    const selected = options.find((option) => option.key === key);
    if (onSelect) onSelect(selected);
  };
  useEffect(() => {
    getHubListData();
  }, []);
  const getHubListData = async () => {
    try {
      const result = await getAllHubsListAPI();
      if (result?.statusCode === 200) {
        let hubList = result?.results;
        hubList = hubList?.map((item) => {
          return { label: uppercaseFirstChar(item?.hub_name), key: item?.id };
        });
        if (allOption) {
          hubList.unshift({ label: "All Hubs", key: "all" });
        }
        if (Array?.isArray(excludeOption) && excludeOption?.length > 0) {
          hubList = hubList?.filter((item) => !excludeOption?.includes(item?.label));
        }
        setOptions(hubList);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const handleChange = () => {};
  return (
    <Dropdown
      overlayClassName="max-h-[50vh] overflow-y-auto shadow-lg custom-scrollbar"
      menu={{
        items: options,
        onClick: handleMenuClick,
      }}
      trigger={["click"]}
    >
      <button
        className={"ct-date-range-text"}
        style={{
          backgroundColor: "rgb(255,255,255)",
          border: "solid",
          borderColor: "rgb(216,217,220)",
          borderRadius: "15px",
          fontWeight: 400,
          color: "rgb(113,118,128)",
        }}
      >
        {value ? options.find((option) => option.key === value)?.label : buttonLabel}
        <SvgIcon type={"down-arrow-point"} />
      </button>
      {/* <HtmlButton className={'ct-date-range-text'}
      style={{
        backgroundColor:"rgb(255,255,255)", border: "solid",borderColor:"rgb(216,217,220)",borderRadius:"15px",
        fontWeight: 400,
        color: "rgb(113,118,128)"
        }}
        type={'dark'}  outline={true} text={buttonLabel} svgType={'down-arrow-point'} svgPosition="right" /> */}
    </Dropdown>
  );
};
/** @deprecated  */
export const ActionPopup = React.memo((props) => {
  const {
    open,
    mask = true,
    width = "auto",
    title,
    fields = [],
    saveText = "Save",
    discardText = "Discard",
    onClose,
    onSave,
    discardSaveLoading = false,
    onDiscardFieldsChange,
    messageOnly,
    useAlert = true,
    maxHeight,
    errorAlert = true,
    onPopupChange = () => {},
    confirmationText = "Are You Sure",
    confirmation = false,
    beforeConfirm = () => {},
    saveDisabled = false,
  } = props;

  const [internalOpen, setInternalOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ message: "", type: "" });
  const prevOpenRef = useRef(false);
  const prevValuesRef = useRef(null);

  const clearAlert = () => {
    setAlert({
      message: "",
      type: "",
    });
  };

  useEffect(() => {
    const wasOpen = prevOpenRef.current;
    const isOpen = props.open;

    setInternalOpen(isOpen);

    // Only initialize/update formData when modal opens or when values actually change
    if (isOpen) {
      // Modal just opened - initialize formData
      if (!wasOpen && props?.values) {
        setFormData(props?.values);
        prevValuesRef.current = props?.values;
      }
      // Modal is already open - only update if values actually changed
      else if (wasOpen && props?.values) {
        // Deep comparison to check if values actually changed
        try {
          const currentValuesStr = JSON.stringify(props.values);
          const prevValuesStr = prevValuesRef.current
            ? JSON.stringify(prevValuesRef.current)
            : null;
          if (currentValuesStr !== prevValuesStr) {
            setFormData(props?.values);
            prevValuesRef.current = props?.values;
          }
        } catch (error) {
          // Fallback: shallow comparison if JSON.stringify fails
          if (prevValuesRef.current !== props?.values) {
            setFormData(props?.values);
            prevValuesRef.current = props?.values;
          }
        }
      }
    } else if (wasOpen && !isOpen) {
      // Modal just closed - reset refs but keep formData until handleClose is called
      prevValuesRef.current = null;
    }

    prevOpenRef.current = isOpen;
  }, [props.open, props?.values]);

  // Reset data when modal closes
  const resetData = () => {
    setFormData({});
    prevValuesRef.current = null;
  };

  const handleClose = () => {
    setInternalOpen(false);
    resetData();
    clearAlert();
    onClose();
  };

  const handleChange = useCallback(
    (name, value) => {
      onPopupChange(name, value);
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      if (onDiscardFieldsChange) {
        onDiscardFieldsChange(name, value);
      }
    },
    [onDiscardFieldsChange]
  );

  const save = async () => {
    setLoading(true);
    try {
      const res = await onSave?.(formData, props?.record, props);
      if (res?.statusCode === 200) {
        setAlert({
          type: "success",
          message: "Successfully completed. ",
        });
        setTimeout(() => {
          handleClose();
        }, 200);
      } else {
        setAlert({
          type: "error",
          message: "Unable to process request.",
        });
      }
    } catch (error) {
      const message = takeReadAbelError(error);
      setAlert({
        type: "error",
        message: message,
      });
    }
    setLoading(false);
  };
  const renderedFields = (f) => {
    return f?.map((field, index) => {
      switch (field?.type) {
        case "HtmlTextArea":
          return (
            <div>
              {field.label && <span>{field.label}</span>}
              <HtmlTextArea
                key={index}
                value={formData[field.name]}
                allTimeEditMode={true}
                onChange={(e) => handleChange(e.target.name, e.target.value)}
                {...field}
              />
            </div>
          );
        case "ToggleSwitch":
          return (
            <div key={index} className="flex items-center gap-2 mb-4">
              {field.label && <span>{field.label}</span>}
              <ToggleSwitch
                checked={!!formData[field.name]}
                onChange={(e) => handleChange(field.name, e)}
                {...field}
              />
            </div>
          );
        case "p":
          return (
            <p key={index} {...field}>
              {field.text}
            </p>
          );
        case "checkbox":
          return (
            <div className="">
              <label className="flex items-center gap-1 ">
                <input
                  onChange={(e) => handleChange(e.target.name, e.target?.checked)}
                  // checked={field?.hasOwnProperty('checked')?field?.checked:formData[field.name]}
                  // checked={typeof field?.checked === 'boolean' ? field.checked : formData[field.name]}
                  checked={formData[field?.name]}
                  key={index}
                  {...field}
                  type="checkbox"
                />
                {field?.label}
              </label>
            </div>
          );
        case "collapse":
          return (
            <div>
              <HtmlCollapse
                {...field}
                titleProperties={{ style: { fontSize: "15px" } }}
                title={renderedFields(field?.title || [])}
                // headerContent={<div className="bg-red-500">hiiii</div>}
                open={formData[field?.name] || field?.open ? true : false}
                // open={true}
                element={renderedFields(field?.fields || [])}
              />
            </div>
          );
        case "confirmation-icon":
          return (
            <p key={index} {...field}>
              <SvgIcon
                size={field?.size || 70}
                color={field?.color || "#f6a000"}
                type={"confirmation-icon"}
              />
            </p>
          );
        case "note":
          return (
            <p key={index} {...field} className="text-left text-[12px] text-red-500">
              {field?.text}
            </p>
          );
        case "ul": {
          return (
            <ul key={index} {...field} className="list-disc pl-5">
              {field?.items?.map((item, itemIndex) => (
                <li key={itemIndex} className="text-[15px] font-dm-sans-nocolor-400 text-[#616161]">
                  {item}
                </li>
              ))}
            </ul>
          );
        }
        case "select":
          return (
            <div key={index} className={field?.className}>
              {field?.label && (
                <p>
                  {field?.label} {field?.required && <span className="text-red-500">*</span>}
                </p>
              )}
              <select
                onChange={(e) => handleChange(e.target.name, e.target.value)}
                name={field?.name}
                value={formData[field?.name]}
                className={`form-input p-2 w-full text-sm font-light text-gray-600 bg-transparent border border-gray-300 rounded-md focus:outline-none focus:ring-0`}
              >
                <option value={""}>Select</option>
                {field?.options &&
                  field?.options?.map((item, index) => {
                    return <option value={item?.value}>{item?.label}</option>;
                  })}
              </select>
            </div>
          );
        case "input":
          return (
            <div key={index} className={field?.className}>
              {field?.label && (
                <p>
                  {field?.label} {field?.required && <span className="text-red-500">*</span>}
                </p>
              )}
              <input
                onChange={(e) => handleChange(e.target.name, e.target.value)}
                name={field?.name}
                value={formData[field?.name]}
                className={`form-input p-2 w-full text-sm font-light text-gray-600 bg-transparent border border-gray-300 rounded-md focus:outline-none focus:ring-0`}
              />
            </div>
          );
        default:
          return null;
      }
    });
  };

  return (
    <ShowContentModal
      open={internalOpen}
      title={title}
      close={handleClose}
      mask={mask}
      width={width}
      maxHeight={maxHeight}
      element={
        <div>
          {(useAlert || (errorAlert && alert?.type === "error")) && alert?.message !== "" && (
            <HtmlAlert
              message={alert?.message}
              type={alert?.type}
              showIcon={true}
              onClose={clearAlert}
            />
          )}
          {messageOnly && <div className="font-semibold">{messageOnly}</div>}
          <div className="flex flex-col gap-2">{renderedFields(fields)}</div>
          <div className="flex justify-end items-center gap-4 mt-4">
            <HtmlButton onClick={handleClose} type="discard" text={discardText} loading={false} />
            <HtmlButton
              onClick={() => {
                // save()
                save();
              }}
              type="save"
              text={saveText}
              disabled={loading || saveDisabled}
              loading={loading}
              beforeConfirm={beforeConfirm}
              confirmation={confirmation}
              confirmationText={confirmationText}
              style={{
                borderRadius: "23px",
                padding: "8px",
              }}
            />
          </div>
        </div>
      }
    />
  );
});
/** @deprecated  */
export const openNotification = ({
  type = "info",
  message = "",
  description = "",
  placement = "top",
  duration = 0,
  pauseOnHover,
  showProgress,
}) => {
  notification[type]({
    message,
    description,
    placement,
    duration,
    pauseOnHover,
    showProgress,
  });
};
/** @deprecated  */
export const LightButton = ({
  text,
  onClick = () => {},
  disabled,
  type = "default",
  rightIcon,
  className = "",
  extraClass = "",
}) => {
  const baseClass = `${className} inline-block px-4 py-1.5 rounded-md text-sm font-medium border transition`;

  const typeStyles = {
    form: "bg-blue-50 border-blue-200 text-blue-600 hover:bg-blue-100 active:bg-blue-200 text-nowrap",
    update:
      "bg-yellow-50 border-yellow-300 text-yellow-700 hover:bg-yellow-100 active:bg-yellow-200 text-nowrap",
    delete: "bg-red-50 border-red-300 text-red-700 hover:bg-red-100 active:bg-red-200 text-nowrap",
    history:
      "bg-violet-50 border-violet-200 text-violet-600 hover:bg-violet-100 active:bg-violet-200 text-nowrap",
    done: "bg-green-50 border-green-300 text-green-700 hover:bg-green-100 active:bg-green-200 text-nowrap",
    reopen:
      "bg-orange-50 border-orange-200 text-orange-600 hover:bg-orange-100 active:bg-orange-200 text-nowrap",
    upload:
      "bg-blue-100 border-blue-300 text-blue-700 hover:bg-blue-200 active:bg-blue-300 text-nowrap",
    fill_form:
      "bg-teal-40 border-teal-200 text-teal-600 hover:bg-teal-70 active:bg-teal-100 text-nowrap",
    completed:
      "bg-[#f6ffed] hover:!bg-[#f6ffed] border-[#b7eb8f] text-[#52c41a] text-nowrap pointer-events-none",
    completed_not_disabled:
      "bg-[#f6ffed] hover:!bg-[#f6ffed] border-[#b7eb8f] text-[#52c41a] text-nowrap",
    not_done_preview:
      "bg-green-100 hover:!bg-green-200 border-green-300 text-green-700 text-nowrap",
    preview: "bg-green-100 hover:bg-green-200 border-green-300 text-green-700 text-nowrap",
    pending: "bg-yellow-100 hover:!bg-yellow-200 border-yellow-300 text-yellow-700 text-nowrap",
    review: "bg-orange-100 hover:!bg-orange-200 border-orange-300 text-orange-700 text-nowrap",
    re_upload: "bg-red-100 hover:!bg-red-200 border-red-300 text-red-700 text-nowrap",
    default:
      "bg-white border-gray-300 text-gray-700 hover:bg-gray-100 active:bg-gray-200 text-nowrap",
  };

  const disabledClass = "pointer-events-none opacity-50";
  let element = text;
  if (type === "completed") {
    element = (
      <div className="flex gap-2">
        <div>{text}</div>
        <div>
          <FigmaSvgIcon type="complete" />
        </div>
      </div>
    );
  } else if (type === "completed_not_disabled") {
    element = (
      <div className="flex gap-2">
        <div>{text}</div>
        <div>
          <FigmaSvgIcon type="complete" />
        </div>
      </div>
    );
  } else if (type === "pending") {
    element = (
      <div className="flex gap-2">
        <div>{text}</div>
        <div>
          <FigmaSvgIcon type="pending" />
        </div>
      </div>
    );
  } else if (type === "review") {
    element = (
      <div className="flex gap-2">
        <div>{text}</div>
        <div>{/* <FigmaSvgIcon type="review" /> */}</div>
      </div>
    );
  } else if (type === "not_done_preview") {
    element = (
      <div className="flex gap-2 items-center">
        {/* <div>
          <FigmaSvgIcon type="complete" />
        </div> */}
        <div>
          <Eye size={18} />
        </div>
      </div>
    );
  } else if (type === "delete") {
    element = (
      <div className="flex gap-2 items-center">
        <div>{text}</div>
        <div className="w-4 h-4 bg-red-500 rounded-full flex items-center justify-center">
          <svg
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M18 6L6 18" />
            <path d="M6 6l12 12" />
          </svg>
        </div>
      </div>
    );
  } else if (type === "preview") {
    element = (
      <div className="flex gap-2 items-center">
        <div>
          <FigmaSvgIcon type="complete" />
        </div>
        <div>
          <Eye size={18} />
        </div>
      </div>
    );
  }
  return (
    <div
      onClick={!disabled ? onClick : undefined}
      className={` min-w-[85px] ${extraClass ? "w-[185px]" : ""} flex gap-2 justify-center items-center ${baseClass} ${
        disabled ? disabledClass : "cursor-pointer"
      } ${typeStyles[type] || typeStyles?.default}`}
    >
      <div>{element}</div>
      {rightIcon && (
        <div>
          <SvgIcon type={rightIcon} className="" />
        </div>
      )}
    </div>
  );
};
/** @deprecated  */
export const HtmlDiv = ({ text = "" }) => {
  return (
    <div
      className={`flex justify-start items-center custom-date-input w-full border-[1px] bg-white border-[#dfdfdf] h-[38px] text-[15px] px-[11px] rounded-[6px] input-value-dm-400`}
    >
      {text}
    </div>
  );
};
/** @deprecated  */
export const useUpdateUrlQuery = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (newParams = {}) => {
    const searchParams = new URLSearchParams(location.search);

    Object.entries(newParams).forEach(([key, value]) => {
      if (value === undefined || value === null || value === "") {
        searchParams.delete(key);
      } else {
        searchParams.set(key, value);
      }
    });

    const newQueryString = searchParams.toString();
    const newUrl = `${location.pathname}${newQueryString ? `?${newQueryString}` : ""}`;

    navigate(newUrl, { replace: true }); // This updates the URL and triggers rerender
  };
};
/** @deprecated  */
export const SkeletonLoader = ({ fieldCount = 8, columns = 1 }) => {
  const columnClasses = {
    1: "grid-cols-1",
    2: "sm:grid-cols-2",
    3: "sm:grid-cols-3",
    4: "sm:grid-cols-4",
    5: "sm:grid-cols-5",
    6: "sm:grid-cols-6",
  };

  return (
    <div className={`grid gap-6 p-2 animate-pulse ${columnClasses[columns] || "grid-cols-1"}`}>
      {[...Array(fieldCount)].map((_, i) => (
        <div key={i} className="flex flex-col gap-2">
          <div className="h-4 w-[180px] rounded shimmer" />
          <div className="h-10 w-full rounded shimmer" />
        </div>
      ))}
    </div>
  );
};
/** @deprecated  */
export const HoverTransitionTag = ({ oldValue, newValue, isParsingNeed }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [position, setPosition] = useState(null);
  const wrapperRef = useRef();

  useEffect(() => {
    if (isHovered && wrapperRef.current) {
      const rect = wrapperRef.current.getBoundingClientRect();
      const popupWidth = 500;
      const popupHeight = 70;
      const margin = 8;

      const fitsAbove = rect.top >= popupHeight + margin;
      const fitsBelow = window.innerHeight - rect.bottom >= popupHeight + margin;

      const top = fitsAbove
        ? rect.top - popupHeight - margin
        : fitsBelow
          ? rect.bottom + margin
          : Math.max(0, rect.bottom + margin); // fallback

      const left = Math.min(
        Math.max(rect.left + rect.width / 2 - popupWidth / 2, 8),
        window.innerWidth - popupWidth - 8
      );

      setPosition({
        top,
        left,
      });
    } else {
      setPosition(null);
    }
  }, [isHovered]);

  if (isParsingNeed) {
    oldValue = parseAndJoinStringArray(oldValue);
    newValue = parseAndJoinStringArray(newValue);
  }

  return (
    <>
      <div
        ref={wrapperRef}
        style={{
          display: "inline-block",
          cursor: "pointer",
          zIndex: 1,
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* newValue */}
        <span>{<ExpandableTextModal text={newValue} title="Summary Change" /> || "---"}</span>
      </div>

      {isHovered && position && (
        <div
          style={{
            position: "fixed",
            top: `${position.top}px`,
            left: `${position.left}px`,
            width: "500px",
            backgroundColor: "#fff",
            boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
            border: "1px solid #ccc",
            borderRadius: "8px",
            padding: "10px",
            fontSize: "13px",
            color: "#333",
            zIndex: 999999,
            wordBreak: "break-word",
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
            pointerEvents: "none", // ensures hover state is maintained
          }}
        >
          <div style={{ fontWeight: 600, color: "#6b7280", width: "100%" }}>Change Summary</div>
          <div style={{ color: "#dc2626", flex: 1, minWidth: "200px" }}>
            <span style={{ fontWeight: 600 }}>Old:</span> {oldValue || "---"}
          </div>
          <div style={{ color: "#16a34a", flex: 1, minWidth: "200px" }}>
            <span style={{ fontWeight: 600 }}>New:</span> {newValue || "---"}
          </div>
        </div>
      )}
    </>
  );
};
/** @deprecated  */
export const formatDateTimeForBackend = (dateObj, timeStr) => {
  const [hours, minutes, seconds] = timeStr.split(":");
  dateObj.setHours(+hours);
  dateObj.setMinutes(+minutes);
  dateObj.setSeconds(+seconds || 0);

  const pad = (n) => String(n).padStart(2, "0");

  const datePart = `${dateObj.getFullYear()}-${pad(
    dateObj.getMonth() + 1
  )}-${pad(dateObj.getDate())}`;
  const timePart = `${pad(dateObj.getHours())}:${pad(
    dateObj.getMinutes()
  )}:${pad(dateObj.getSeconds())}`;

  return `${datePart} ${timePart}`;
};
/** @deprecated  */
export const TimeOnlyPicker = ({ onChange, value, disabled = false }) => {
  const [time, setTime] = useState(value ? value.split(" ")[1]?.slice(0, 5) : "");

  const handleChange = (e) => {
    const selectedTime = e.target.value; // e.g., "11:30"
    setTime(selectedTime);

    const today = new Date();
    const datePart = today.toISOString().split("T")[0]; // "YYYY-MM-DD"
    const formattedDateTime = `${datePart} ${selectedTime}:00`; // "YYYY-MM-DD HH:mm:00"

    if (onChange) onChange(formattedDateTime);
  };

  return (
    <div className="w-full relative">
      <input
        // id="custom-time-input"
        type="time"
        className={`w-full border-[1px] bg-white border-[#dfdfdf] hover:border-[#4B465C] h-[38px] text-[15px] px-[11px] rounded-[6px] pr-[6px]  ${
          disabled ? "pointer-events-none input-value-dm-400" : "input-value-dm-400"
        }`}
        value={time}
        onChange={handleChange}
        disabled={disabled}
        style={{ position: "relative", zIndex: 1 }}
      />

      {/* SVG Icon */}
      {/* <div
        className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer z-10"
        onClick={openTimePicker}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-5 h-5 text-gray-500 pointer-events-auto"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 6v6l4 2m6-2a10 10 0 11-20 0 10 10 0 0120 0z"
          />
        </svg>
      </div> */}
    </div>
  );
};

export default TimeOnlyPicker;
/** @deprecated  */
export const formatTimeInWs = (timeStr) => {
  if (timeStr.startsWith("0 days")) {
    return timeStr.replace("0 days ", "");
  }
  return timeStr;
};
/** @deprecated  */
export const CreatableSelect = ({
  options = [],
  onChange,
  value,
  fallbackValue,
  placeholder = "Select or type...",
  isDisabled = false,
  isClearable = true,
  noOptionsMessage = "No options found",
  hideClearIndicator = false,
  className = "",
  isMulti = false,
}) => {
  const [inputValue, setInputValue] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState(options);
  const [isFocused, setIsFocused] = useState(false);
  // Ref to track if a selection/creation is in progress (prevents race condition on Windows)
  const isSelectingRef = useRef(false);

  // Find the current selected option(s)
  const getSelectedOption = () => {
    if (isMulti) {
      if (!Array.isArray(value)) return [];
      return value.map(
        (val) => options.find((option) => option.value === val) || { label: val, value: val }
      );
    } else {
      if (!value) return null;
      return options.find((option) => option.value === value) || { label: value, value: value };
    }
  };

  // Filter options based on input value (case-insensitive)
  const filterOptions = (searchValue) => {
    if (!searchValue || searchValue.trim() === "") {
      setFilteredOptions(options);
      return;
    }

    const filtered = options.filter((option) =>
      option.label.toLowerCase().includes(searchValue.toLowerCase())
    );
    setFilteredOptions(filtered);
  };

  // Handle input change - don't apply textBeautifyFunction on every keystroke
  const handleInputChange = (newValue) => {
    // Store the raw input value without formatting to allow proper backspace
    setInputValue(newValue);
    filterOptions(newValue);

    // If input is cleared, show all options
    if (!newValue || newValue.trim() === "") {
      setFilteredOptions(options);
    }
  };

  // Handle option selection
  const handleOptionSelect = (selectedOption) => {
    // Mark that we're in the process of selecting (prevents onBlur from clearing)
    isSelectingRef.current = true;

    if (isMulti) {
      const currentValues = Array.isArray(value) ? value : [];
      const newValues = selectedOption
        ? [...currentValues, selectedOption.value]
        : currentValues.filter((val) => val !== selectedOption.value);
      onChange(newValues);
    } else {
      onChange(selectedOption ? selectedOption.value : null);
      setIsOpen(false);
    }
    setInputValue("");

    // Reset the selecting flag after a delay
    setTimeout(() => {
      isSelectingRef.current = false;
    }, 200);
  };

  // Handle creating new option
  const handleCreateOption = () => {
    if (!inputValue.trim()) return;

    // Mark that we're in the process of selecting/creating (prevents onBlur from clearing)
    isSelectingRef.current = true;

    // Apply textBeautifyFunction when creating the option
    const formattedValue = textBeautifyFunction(inputValue);
    const newOption = {
      label: formattedValue,
      value: formattedValue,
    };

    if (isMulti) {
      const currentValues = Array.isArray(value) ? value : [];
      if (!currentValues.includes(newOption.value)) {
        onChange([...currentValues, newOption.value]);
      }
    } else {
      onChange(newOption.value);
    }

    // Clear input and close dropdown after a short delay to show the created value
    setTimeout(() => {
      setInputValue("");
      setIsOpen(false);
      // Reset the selecting flag after everything is done
      isSelectingRef.current = false;
    }, 200);
  };

  // Handle key press
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && inputValue.trim()) {
      e.preventDefault();
      handleCreateOption();
    } else if (e.key === "Escape") {
      setIsOpen(false);
      setInputValue("");
    }
  };

  // Handle clear
  const handleClear = () => {
    onChange(isMulti ? [] : null);
    setInputValue("");
    setFilteredOptions(options); // Show all options when clearing
  };

  const selectedOption = getSelectedOption();
  const formattedInputValue = inputValue; // Use raw input value for display
  const showCreateOption =
    inputValue.trim() &&
    !filteredOptions.some((option) => option.label.toLowerCase() === inputValue.toLowerCase());

  // Styling to match ReactSelect and Input components
  const inputClassName = `w-full border-[1px] bg-white border-[#dfdfdf] hover:border-[#4B465C] h-[38px] text-[15px] px-[11px] rounded-[6px] ${
    isDisabled ? "input-value-dm-400 pointer-events-none" : "input-value-dm-400"
  } focus:outline-none focus:border-[#4B465C] ${isFocused ? "border-[#4B465C]" : ""}`;

  const displayValue = selectedOption
    ? isMulti
      ? `${selectedOption.length} selected`
      : selectedOption.label
    : "";
  const placeholderText = selectedOption ? "" : placeholder;

  return (
    <div className={`relative ${className}`}>
      <div className="relative">
        <input
          type="text"
          value={inputValue || displayValue}
          onChange={(e) => handleInputChange(e.target.value)}
          onFocus={() => {
            setIsOpen(true);
            setIsFocused(true);
            // Clear the input when focusing to allow typing
            if (selectedOption && !inputValue) {
              setInputValue("");
            }
            // Filter options based on current input value, not show all
            const currentValue = inputValue || displayValue || "";
            if (currentValue.trim()) {
              filterOptions(currentValue);
            } else {
              setFilteredOptions(options);
            }
          }}
          onBlur={() => {
            setIsFocused(false);
            // Delay closing to allow option selection
            setTimeout(() => {
              // Skip clearing if a selection/creation is in progress (fixes Windows race condition)
              if (isSelectingRef.current) {
                return;
              }

              setIsOpen(false);
              // Clear input if user typed something that doesn't match any option
              // and didn't create a new option (no valid selection was made)
              if (inputValue && inputValue.trim() !== "") {
                // Check if the input value matches any existing option
                const exactMatch = options.some(
                  (option) => option.label.toLowerCase() === inputValue.toLowerCase()
                );

                // If no exact match and no option was selected, clear the input
                if (!exactMatch && !value) {
                  setInputValue("");
                }
              } else if (!inputValue || inputValue.trim() === "") {
                setInputValue("");
              }
            }, 150);
          }}
          onKeyDown={handleKeyDown}
          placeholder={placeholderText}
          disabled={isDisabled}
          className={inputClassName}
          style={{
            fontFamily: "'DM Sans', sans-serif",
            fontWeight: 400,
            lineHeight: "24px",
            letterSpacing: "0px",
            color: inputValue || displayValue ? "#4B465C" : "#aaaaaa",
            opacity: 0.85,
          }}
        />

        {/* Dropdown arrow - only show when no value is selected */}
        {!value || (isMulti && value.length === 0) ? (
          <div className="absolute inset-y-0 right-[1px] flex items-center pr-3 pointer-events-none">
            <svg
              className="w-4 h-4 text-gray-500 opacity-90"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </div>
        ) : null}

        {/* Clear button - only show when value is selected */}
        {!hideClearIndicator && value && (isMulti ? value.length > 0 : true) && (
          <button
            onClick={handleClear}
            className="absolute inset-y-0 right-[0px] opacity-80 flex items-center pr-3 text-gray-400 hover:text-gray-600 z-10"
            style={{
              fontSize: "13px",
              cursor: "pointer",
              color: "#333",
            }}
          >
            <div className="px-[3px] z-20">✖</div>
          </button>
        )}
      </div>

      {/* Dropdown menu */}
      {isOpen && (
        <div
          className="absolute z-50 w-full mt-1 bg-white border border-[#dfdfdf] rounded-[6px] shadow-lg max-h-60 overflow-auto"
          style={{ marginTop: "5px" }}
        >
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option, index) => (
              <div
                key={index}
                onMouseDown={() => {
                  // Set flag BEFORE blur fires (mouseDown fires before blur)
                  isSelectingRef.current = true;
                }}
                onClick={() => handleOptionSelect(option)}
                className="px-3 py-2 hover:bg-[#e0e0e0] cursor-pointer flex items-center justify-between"
                style={{
                  backgroundColor: "#fff",
                  color: "#4B465C",
                  padding: "8px",
                  fontSize: "15px",
                  fontFamily: "'DM Sans', sans-serif",
                  fontWeight: 400,
                  opacity: 1,
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                <span>{option.label}</span>
                {isMulti && Array.isArray(value) && value.includes(option.value) && (
                  <span className="text-blue-500">✓</span>
                )}
              </div>
            ))
          ) : (
            <div
              className="px-3 py-2 text-center"
              style={{
                color: "#4B465C",
                padding: "8px",
                fontSize: "15px",
                fontFamily: "'DM Sans', sans-serif",
                fontWeight: 400,
              }}
            >
              {noOptionsMessage}
            </div>
          )}

          {/* Create new option */}
          {showCreateOption && (
            <div
              onMouseDown={() => {
                // Set flag BEFORE blur fires (mouseDown fires before blur)
                isSelectingRef.current = true;
              }}
              onClick={handleCreateOption}
              className="px-3 py-2 hover:bg-blue-50 cursor-pointer border-t border-[#dfdfdf] text-blue-600"
              style={{
                padding: "8px",
                fontSize: "15px",
                fontFamily: "'DM Sans', sans-serif",
                fontWeight: 400,
              }}
            >
              Create "{formattedInputValue}"
            </div>
          )}
        </div>
      )}

      {/* Click outside to close */}
      {isOpen && (
        <div
          className="fixed inset-0 z-40"
          onClick={() => {
            setIsOpen(false);
            // Don't clear input immediately - let the blur handler handle it
          }}
        />
      )}
    </div>
  );
};

// TooltipPopup Component
/** @deprecated  */
export const TooltipPopup = ({
  show,
  message,
  position = "top", // "top", "bottom", "left", "right"
  maxWidth = "400px",
  className = "",
}) => {
  if (!show || !message) return null;

  const getPositionClasses = () => {
    switch (position) {
      case "top":
        return "absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2";
      case "bottom":
        return "absolute top-full left-1/2 transform -translate-x-1/2 mt-2";
      case "left":
        return "absolute right-full top-1/2 transform -translate-y-1/2 mr-2";
      case "right":
        return "absolute left-full top-1/2 transform -translate-y-1/2 ml-2";
      default:
        return "absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2";
    }
  };

  const getArrowClasses = () => {
    switch (position) {
      case "top":
        return "absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-[#212121]";
      case "bottom":
        return "absolute bottom-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-b-4 border-transparent border-b-[#212121]";
      case "left":
        return "absolute left-full top-1/2 transform -translate-y-1/2 w-0 h-0 border-t-4 border-b-4 border-l-4 border-transparent border-l-[#212121]";
      case "right":
        return "absolute right-full top-1/2 transform -translate-y-1/2 w-0 h-0 border-t-4 border-b-4 border-r-4 border-transparent border-r-[#212121]";
      default:
        return "absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-[#212121]";
    }
  };

  return (
    <div className={`${getPositionClasses()} z-50 animate-fade-in ${className}`}>
      <div
        className="bg-[#212121] text-white text-sm px-3 py-2 rounded-lg shadow-lg relative w-[200px]"
        style={{ maxWidth: maxWidth }}
      >
        <div className="text-center whitespace-normal break-words">{message}</div>
        {/* Arrow pointer */}
        <div className={getArrowClasses()}></div>
      </div>
    </div>
  );
};
/** @deprecated  */
export const ErrorInfoButton = ({
  onClick = () => {},
  disabled = false,
  className = "",
  size = "sm",
}) => {
  const sizeClasses = {
    sm: "w-6 h-6 text-xs",
    md: "w-8 h-8 text-sm",
    lg: "w-10 h-10 text-base",
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`
        ${sizeClasses[size]}
        bg-white border border-red-500 text-red-500
        rounded-full flex items-center justify-center
        hover:bg-red-50 hover:border-red-600 hover:text-red-600
        disabled:opacity-50 disabled:cursor-not-allowed
        transition-all duration-200 ease-in-out
        shadow-sm hover:shadow-md
        ${className}
      `}
      title="View error details"
    >
      <svg
        width="12"
        height="12"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="w-3 h-3"
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>
    </button>
  );
};
/** @deprecated  */
export const TooltipWrapper = ({
  content = "Tooltip content",
  children,
  triggerType = "hover",
  placement = "top", // top, left, right, bottom , topLeft, topRight, bottomLeft, bottomRight
  disabled = false,
  tooltipStyle = "",
}) => {
  const [open, setOpen] = useState(false);
  const [dynamicPlacement, setDynamicPlacement] = useState(placement);
  const wrapperRef = useRef(null);
  const handleMouseEnter = () => {
    if (triggerType === "hover" && !disabled) setOpen(true);
  };

  const handleMouseLeave = () => {
    if (triggerType === "hover") setOpen(false);
  };

  const handleClick = () => {
    if (triggerType === "hover") setOpen(false); // hide tooltip on click
  };
  const calculateBestPlacement = () => {
    const element = wrapperRef.current;
    if (!element) return;

    const rect = element.getBoundingClientRect();
    const spaceTop = rect.top;
    const spaceBottom = window.innerHeight - rect.bottom;
    const spaceLeft = rect.left;
    const spaceRight = window.innerWidth - rect.right;

    // Decide which direction has the most room
    const maxSpace = Math.max(spaceTop, spaceBottom, spaceLeft, spaceRight);

    let bestPlacement = "top";
    if (maxSpace === spaceBottom) bestPlacement = "bottom";
    else if (maxSpace === spaceTop) bestPlacement = "top";
    else if (maxSpace === spaceLeft) bestPlacement = "left";
    else if (maxSpace === spaceRight) bestPlacement = "right";

    setDynamicPlacement(bestPlacement);
  };

  useEffect(() => {
    if (!open) return;
    // Recalculate if window resizes while tooltip is open
    calculateBestPlacement();
    // window.addEventListener("resize", handleResize);
    // return () => window.removeEventListener("resize", handleResize);
  }, [open]);

  return (
    <Tooltip
      title={content}
      // trigger={triggerType}
      trigger={triggerType === "hover" ? [] : triggerType} // prevent default hover if we manage it
      // placement={placement}
      placement={dynamicPlacement}
      color="rgba(0,0,0,0.85)"
      overlayInnerStyle={{
        borderRadius: "8px",
        fontSize: "14px",
        padding: "8px 12px",
      }}
      // open={disabled ? false : undefined}
      open={disabled ? false : triggerType === "hover" ? open : undefined}
      autoAdjustOverflow={true} // enable (default)
    >
      <div
        ref={wrapperRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={handleClick}
        className={`inline-flex items-center gap-2 cursor-pointer ${tooltipStyle} `}
      >
        {children}
      </div>
    </Tooltip>
  );
};

// Beautiful Call Icon Component
/** @deprecated  */
export const CallIcon = ({ onClick, isCalling = false, disabled = false }) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled || isCalling}
      className={`relative p-2.5 rounded-2xl transition-all duration-300 ${
        isCalling
          ? "bg-gradient-to-br from-blue-50 to-indigo-50 cursor-not-allowed scale-95"
          : "bg-gradient-to-br from-blue-500 via-indigo-500 to-indigo-500 hover:from-blue-400 hover:via-indigo-600 hover:to-indigo-700 hover:shadow-2xl hover:scale-110 cursor-pointer shadow-lg"
      }`}
      title="Click to call"
    >
      {isCalling && (
        <>
          <span className="absolute inset-0 rounded-2xl bg-blue-400 opacity-75 animate-ping"></span>
          <span
            className="absolute inset-0 rounded-2xl bg-indigo-400 opacity-50 animate-ping"
            style={{ animationDelay: "150ms" }}
          ></span>
        </>
      )}
      <svg
        className={`w-6 h-6 relative z-10 transition-all duration-300 ${
          isCalling ? "text-blue-600 animate-pulse" : "text-white drop-shadow-lg"
        }`}
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        {/* Modern Telephone Handset */}
        <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z" />
      </svg>
    </button>
  );
};

// Unified Call Modal Component
/** @deprecated  */
export const CallModal = ({
  open,
  onClose,
  modalState = "confirm", // 'confirm', 'calling', 'success', 'error'
  driverName = "",
  driverId = "",
  errorMessage = "",
  onConfirmCall,
  autoCloseOnSuccess = true,
  autoCloseDelay = 5000,
}) => {
  const { capitalizeFirstLetterOfWord } = require("../../controllers/common");
  const [countdown, setCountdown] = React.useState(Math.floor(autoCloseDelay / 1000));

  // Handle countdown and auto-close
  React.useEffect(() => {
    if (modalState === "success" && autoCloseOnSuccess) {
      setCountdown(Math.floor(autoCloseDelay / 1000));

      const countdownInterval = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(countdownInterval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      const timer = setTimeout(() => {
        onClose();
      }, autoCloseDelay);

      return () => {
        clearInterval(countdownInterval);
        clearTimeout(timer);
      };
    }
  }, [modalState, autoCloseOnSuccess, autoCloseDelay, onClose]);

  if (!open) return null;

  return (
    <>
      <style>{`
        @keyframes scale-in {
          0% {
            transform: scale(0);
            opacity: 0;
          }
          50% {
            transform: scale(1.1);
          }
          100% {
            transform: scale(1);
            opacity: 1;
          }
        }
        .animate-scale-in {
          animation: scale-in 0.5s ease-out;
        }
        .animation-delay-75 {
          animation-delay: 75ms;
        }
        .animation-delay-100 {
          animation-delay: 100ms;
        }
        .animation-delay-200 {
          animation-delay: 200ms;
        }

        @keyframes bubble-shadow {
          0%, 100% {
            box-shadow: 0 10px 25px -5px rgba(59, 130, 246, 0.5),
                        0 8px 10px -6px rgba(99, 102, 241, 0.5);
          }
          25% {
            box-shadow: 0 15px 35px -5px rgba(59, 130, 246, 0.6),
                        0 12px 15px -6px rgba(99, 102, 241, 0.6),
                        0 0 25px rgba(79, 70, 229, 0.4);
          }
          50% {
            box-shadow: 0 20px 45px -5px rgba(59, 130, 246, 0.7),
                        0 16px 20px -6px rgba(99, 102, 241, 0.7),
                        0 0 35px rgba(79, 70, 229, 0.5);
          }
          75% {
            box-shadow: 0 15px 35px -5px rgba(59, 130, 246, 0.6),
                        0 12px 15px -6px rgba(99, 102, 241, 0.6),
                        0 0 25px rgba(79, 70, 229, 0.4);
          }
        }

        .bubble-shadow {
          animation: bubble-shadow 2s ease-in-out infinite;
        }
      `}</style>
      <div className="p-8 transition-all duration-300">
        <div className="flex flex-col items-center">
          {/* Confirmation State */}
          {modalState === "confirm" && (
            <>
              <div className="w-full flex flex-col items-center justify-center">
                {" "}
                <div className="p-4 bg-gradient-to-br from-blue-500 via-indigo-500 to-indigo-600 rounded-3xl flex items-center justify-center mb-6 shadow-2xl animate-pulse">
                  <svg
                    className="w-14 h-14 text-white drop-shadow-lg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z" />
                  </svg>
                </div>
                <h2 className="text-3xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent mb-3 text-center">
                  Initiate Call
                </h2>
                <p className="text-gray-600 text-center mb-8 text-base">
                  Are you sure you want to call this driver partner?
                </p>
              </div>

              <div className="bg-gradient-to-br from-blue-50 via-indigo-50 to-indigo-50 rounded-2xl p-4 md:p-6 w-full mb-8 border-2 border-blue-100 shadow-lg">
                <div className="flex items-center justify-center space-x-3 mb-3">
                  <div className="md:w-12 md:h-12 w-8 h-8 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-full flex items-center justify-center shadow-lg">
                    <svg
                      className="md:w-7 md:h-7 w-4 h-4 text-white"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <span className="md:text-2xl text-xl font-bold bg-gradient-to-r from-blue-700 to-indigo-700 bg-clip-text text-transparent">
                    {capitalizeFirstLetterOfWord(driverName)}
                  </span>
                </div>
                <div className="flex items-center justify-center space-x-2 bg-white rounded-xl py-2.5 px-5 shadow-md">
                  <svg className="w-5 h-5 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                  </svg>
                  <span className="text-sm font-semibold text-gray-700">
                    Driver ID: <span className="text-blue-600 font-bold">{driverId || "N/A"}</span>
                  </span>
                </div>
              </div>

              <div className="flex space-x-3 w-[250px] md:w-full">
                <button
                  onClick={onClose}
                  className="
    flex-1 px-6 py-3 rounded-xl font-semibold text-white
    bg-gradient-to-r from-red-500 via-red-600 to-red-700
    shadow-md hover:shadow-xl
    active:scale-95
    transition-all duration-300
    flex items-center justify-center gap-2
  "
                >
                  {/* Sleek, modern cross icon */}
                  <svg
                    className="w-4 h-4 md:w-5 md:h-5 text-white transition-transform duration-200 hover:rotate-0"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="4"
                    viewBox="0 0 24 24"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <line x1="19" y1="5" x2="5" y2="19" />
                    <line x1="5" y1="5" x2="19" y2="19" />
                  </svg>

                  <span>Cancel</span>
                </button>

                <button
                  onClick={onConfirmCall}
                  className="flex-1 px-6 py-4 bg-gradient-to-r from-blue-500 via-indigo-600 to-indigo-600 text-white rounded-xl font-bold hover:from-blue-600 hover:via-indigo-700 hover:to-indigo-700 transition-all duration-200 flex items-center justify-center space-x-2 bubble-shadow"
                >
                  <svg className="md:w-6 md:h-6 w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z" />
                  </svg>
                  <span className="text-nowrap">Call Now</span>
                </button>
              </div>
            </>
          )}

          {/* Calling State */}
          {modalState === "calling" && (
            <>
              <div className="relative mb-8">
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-40 h-40 bg-gradient-to-br from-blue-400 to-indigo-500 rounded-full opacity-20 animate-ping"></div>
                </div>
                <div className="absolute inset-0 flex items-center justify-center animation-delay-75">
                  <div className="w-36 h-36 bg-gradient-to-br from-indigo-500 to-indigo-500 rounded-full opacity-20 animate-ping"></div>
                </div>
                <div className="absolute inset-0 flex items-center justify-center animation-delay-100">
                  <div className="w-32 h-32 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-full opacity-20 animate-ping"></div>
                </div>
                <div className="relative w-28 h-28 bg-gradient-to-br from-blue-500 via-indigo-500 to-indigo-600 rounded-full flex items-center justify-center shadow-2xl">
                  <svg
                    className="w-16 h-16 text-white animate-pulse drop-shadow-xl"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z" />
                  </svg>
                </div>
              </div>

              <h2 className="text-4xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent mb-3 text-center">
                Connecting...
              </h2>

              <p className="text-gray-600 text-center mb-6 text-base">
                Please wait while we connect your call to
              </p>

              <div className="bg-gradient-to-br from-blue-50 via-indigo-50 to-indigo-50 rounded-2xl p-5 shadow-lg border-2 border-blue-100">
                <p className="text-xl font-bold text-gray-900 text-center">
                  {capitalizeFirstLetterOfWord(driverName)}
                </p>
                <p className="text-sm text-blue-600 text-center font-bold mt-2">{driverId}</p>
              </div>

              <div className="flex items-center space-x-3 mt-8">
                <div className="w-3 h-3 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-full animate-bounce shadow-lg"></div>
                <div className="w-3 h-3 bg-gradient-to-r from-indigo-500 to-indigo-500 rounded-full animate-bounce animation-delay-100 shadow-lg"></div>
                <div className="w-3 h-3 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full animate-bounce animation-delay-200 shadow-lg"></div>
              </div>
            </>
          )}

          {/* Success State */}
          {modalState === "success" && (
            <>
              <div className="w-28 h-28 bg-gradient-to-br from-green-400 to-emerald-600 rounded-full flex items-center justify-center mb-6 shadow-2xl animate-scale-in">
                <svg
                  className="w-16 h-16 text-white drop-shadow-xl"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>

              <h2 className="text-4xl font-bold bg-gradient-to-r from-green-600 to-emerald-600 bg-clip-text text-transparent mb-3 text-center">
                Call Connected!
              </h2>

              <p className="text-gray-700 text-center mb-8 text-base px-4">
                Successfully connected your call to{" "}
                <span className="font-bold text-gray-900">
                  {capitalizeFirstLetterOfWord(driverName)}
                </span>{" "}
                ({driverId}).
              </p>

              {autoCloseOnSuccess && countdown > 0 && (
                <p className="text-sm text-gray-500 mb-4">
                  Pop up closing in <span className="font-bold text-green-600">{countdown}</span>{" "}
                  second
                  {countdown !== 1 ? "s" : ""}...
                </p>
              )}

              <button
                onClick={onClose}
                className="px-12 py-4 bg-gradient-to-r from-green-600 to-emerald-700 text-white rounded-xl font-bold hover:from-green-700 hover:to-emerald-800 transition-all duration-200 shadow-lg hover:shadow-2xl"
              >
                Done
              </button>
            </>
          )}

          {/* Error State */}
          {modalState === "error" && (
            <>
              <div className="w-28 h-28 bg-gradient-to-br from-red-500 to-rose-600 rounded-full flex items-center justify-center mb-6 shadow-2xl animate-scale-in">
                <svg
                  className="w-16 h-16 text-white drop-shadow-xl"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>

              <h2 className="text-4xl font-bold bg-gradient-to-r from-red-600 to-rose-600 bg-clip-text text-transparent mb-3 text-center">
                Call Failed
              </h2>

              <p className="text-gray-700 text-center mb-8 text-base px-6">{errorMessage}</p>

              <button
                onClick={onClose}
                className="px-12 py-4 bg-gradient-to-r from-red-600 to-rose-700 text-white rounded-xl font-bold hover:from-red-700 hover:to-rose-800 transition-all duration-200 shadow-lg hover:shadow-2xl"
              >
                Close
              </button>
            </>
          )}
        </div>
      </div>
    </>
  );
};

/**
 * Document Viewer Component
 * Complete PDF/Image viewer with zoom, rotate, pan, download, and open full functionality
 * @param {Object} props
 * @param {string} props.billUrl - URL of the document to display
 */
/** @deprecated  */
export const DocumentViewerControls = ({
  billUrl,
  btnAllowed = ["zoomIn", "zoomOut", "rotate", "reset", "open"],
}) => {
  const containerRef = useRef(null);
  const imageRef = useRef(null);

  // states
  const [isImage, setIsImage] = useState(false);
  const [isPdf, setIsPdf] = useState(false);
  const [pdfLoadError, setPdfLoadError] = useState(false);
  const [pdfDataUrl, setPdfDataUrl] = useState(null); // For blob PDF conversion

  // zoom percent (100 = 1.0) - only for images
  const [zoom, setZoom] = useState(100);
  const [rotation, setRotation] = useState(0);

  // pan in CSS pixels - only for images
  const [pan, setPan] = useState({ x: 0, y: 0 });

  // dragging refs (avoid re-renders)
  const draggingRef = useRef(false);
  const dragStartRef = useRef({ x: 0, y: 0 });
  const panStartRef = useRef({ x: 0, y: 0 });

  // touch pinch refs
  const lastTouchDistanceRef = useRef(null);
  const lastTouchCenterRef = useRef(null);

  // helpers
  const clampZoom = (z) => Math.max(25, Math.min(500, z));

  const getTouchDistance = (t1, t2) => {
    const dx = t2.clientX - t1.clientX;
    const dy = t2.clientY - t1.clientY;
    return Math.hypot(dx, dy);
  };

  const getTouchCenter = (t1, t2) => ({
    x: (t1.clientX + t2.clientX) / 2,
    y: (t1.clientY + t2.clientY) / 2,
  });

  useEffect(() => {
    if (true) {
      // Disable browser-level pinch zoom
      document.addEventListener("touchmove", preventPinch, { passive: false });
      document.addEventListener("gesturestart", preventGesture);
    }

    return () => {
      document.removeEventListener("touchmove", preventPinch);
      document.removeEventListener("gesturestart", preventGesture);
    };
  }, []);

  function preventPinch(e) {
    if (e.touches.length > 1) {
      e.preventDefault(); // Stop browser zoom
    }
  }

  function preventGesture(e) {
    e.preventDefault(); // iOS Safari gesture zoom
  }

  // Helper to check if URL is a PDF
  const isPdfUrl = (url) => {
    if (!url) return false;
    // Check for PDF extension
    if (url.toLowerCase().includes(".pdf")) return true;
    // Check for base64 PDF
    if (url.startsWith("data:application/pdf;base64,")) return true;
    return false;
  };

  // Helper to check if URL is an image by extension
  const isImageUrl = (url) => {
    if (!url) return false;
    const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp", ".svg"];
    const urlLower = url.toLowerCase();
    return imageExtensions.some((ext) => urlLower.includes(ext));
  };

  // Async helper to check content type for blob URLs and convert PDF to data URL
  const checkBlobType = async (url) => {
    try {
      // Fetch the blob data directly (HEAD requests don't work for blob URLs)
      const response = await fetch(url);
      const blob = await response.blob();

      // First check file signatures (most reliable method)
      const arrayBuffer = await blob.slice(0, 12).arrayBuffer();
      const bytes = new Uint8Array(arrayBuffer);
      const signature = String.fromCharCode(bytes[0], bytes[1], bytes[2], bytes[3]);

      // Helper to convert blob to data URL
      const blobToDataUrl = (b) => {
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.readAsDataURL(b);
        });
      };

      // Check for PDF signature (%PDF)
      if (signature === "%PDF") {
        const dataUrl = await blobToDataUrl(blob);
        return { type: "pdf", dataUrl };
      }

      // Check for common image signatures (JPEG, PNG, GIF, WebP)
      if (bytes[0] === 0xff && bytes[1] === 0xd8 && bytes[2] === 0xff) {
        return { type: "image" }; // JPEG
      }
      if (bytes[0] === 0x89 && bytes[1] === 0x50 && bytes[2] === 0x4e && bytes[3] === 0x47) {
        return { type: "image" }; // PNG
      }
      if (bytes[0] === 0x47 && bytes[1] === 0x49 && bytes[2] === 0x46) {
        return { type: "image" }; // GIF
      }
      // WebP: starts with RIFF....WEBP
      if (
        bytes[0] === 0x52 &&
        bytes[1] === 0x49 &&
        bytes[2] === 0x46 &&
        bytes[3] === 0x46 &&
        bytes[8] === 0x57 &&
        bytes[9] === 0x45 &&
        bytes[10] === 0x42 &&
        bytes[11] === 0x50
      ) {
        return { type: "image" }; // WebP
      }

      // Fallback: Check blob.type property
      if (blob.type) {
        if (blob.type.includes("pdf") || blob.type.includes("application/pdf")) {
          const dataUrl = await blobToDataUrl(blob);
          return { type: "pdf", dataUrl };
        } else if (blob.type.includes("image")) {
          return { type: "image" };
        }
      }

      return { type: "unknown" };
    } catch (error) {
      console.error("Error checking blob type:", error);
      return { type: "unknown" };
    }
  };

  // Detect file type when billUrl changes
  useEffect(() => {
    let cancelled = false;

    const detectFileType = async () => {
      if (!billUrl) {
        setIsImage(false);
        setIsPdf(false);
        setPdfLoadError(false);
        setPdfDataUrl(null);
        return;
      }

      // Check if it's a blob URL - need async detection
      if (billUrl.startsWith("blob:")) {
        const result = await checkBlobType(billUrl);

        if (cancelled) {
          return;
        }

        if (result.type === "pdf") {
          setIsPdf(true);
          setIsImage(false);
          setPdfLoadError(false);
          // Store the data URL for rendering (blob URLs don't work well in iframes/embeds)
          if (result.dataUrl) {
            setPdfDataUrl(result.dataUrl);
          }
        } else if (result.type === "image") {
          setIsImage(true);
          setIsPdf(false);
          setPdfDataUrl(null);
          setZoom(100);
          setPan({ x: 0, y: 0 });
          setRotation(0);
        } else {
          // Default to image for unknown blob types
          setIsImage(true);
          setIsPdf(false);
          setPdfDataUrl(null);
          setZoom(100);
          setPan({ x: 0, y: 0 });
          setRotation(0);
        }
        return;
      }

      // Check if it's a PDF
      if (isPdfUrl(billUrl)) {
        setIsPdf(true);
        setIsImage(false);
        setPdfLoadError(false);
        setPdfDataUrl(null); // Not needed for regular URLs
        return;
      }

      // Check if it's an image
      if (isImageUrl(billUrl)) {
        setIsImage(true);
        setIsPdf(false);
        setPdfLoadError(false);
        setPdfDataUrl(null);
        // reset view for images
        setZoom(100);
        setPan({ x: 0, y: 0 });
        setRotation(0);
        return;
      }

      // Default to image for unknown types
      setIsImage(true);
      setIsPdf(false);
      setPdfLoadError(false);
      setPdfDataUrl(null);
      setZoom(100);
      setPan({ x: 0, y: 0 });
      setRotation(0);
    };

    detectFileType();

    return () => {
      cancelled = true;
    };
  }, [billUrl]);

  // Keep pan reset when zoom <= 100
  useEffect(() => {
    if (zoom <= 100) {
      setPan({ x: 0, y: 0 });
    }
  }, [zoom]);

  // Zoom-to-cursor: keep the point under cursor stationary
  const zoomToPoint = (clientX, clientY, newZoom) => {
    const container = containerRef.current;
    if (!container) {
      setZoom(newZoom);
      return;
    }

    const rect = container.getBoundingClientRect();

    // coordinates relative to container center (CSS pixels)
    const cx = clientX - rect.left - rect.width / 2;
    const cy = clientY - rect.top - rect.height / 2;

    const prevScale = zoom / 100;
    const nextScale = newZoom / 100;
    const scaleRatio = nextScale / prevScale;

    // pan is in CSS pixels (we use CSS translate)
    const newPanX = pan.x - cx * (scaleRatio - 1);
    const newPanY = pan.y - cy * (scaleRatio - 1);

    setPan({ x: newPanX, y: newPanY });
    setZoom(newZoom);
  };

  // Wheel handler — supports ctrl + wheel and trackpad pinch (only for images)
  const handleWheel = (e) => {
    if (isPdf) return; // Don't handle wheel for PDFs

    // small deltaY is usually trackpad gesture; treat as zoom
    const isTrackpadPinch = Math.abs(e.deltaY) < 1;

    if (e.ctrlKey || isTrackpadPinch) {
      e.preventDefault();
      const factor = e.deltaY > 0 ? 0.95 : 1.05;
      const newZoom = clampZoom(Math.round(zoom * factor));
      zoomToPoint(e.clientX, e.clientY, newZoom);
    }
  };

  // Mouse drag (pan) - only for images
  const handleMouseDown = (e) => {
    if (isPdf) return; // Don't handle drag for PDFs
    if (e.button !== 0) return;
    draggingRef.current = true;
    dragStartRef.current = { x: e.clientX, y: e.clientY };
    panStartRef.current = { ...pan };
    e.preventDefault();
  };

  const handleMouseMove = (e) => {
    if (isPdf) return; // Don't handle move for PDFs
    if (!draggingRef.current) return;
    const dx = e.clientX - dragStartRef.current.x;
    const dy = e.clientY - dragStartRef.current.y;
    setPan({ x: panStartRef.current.x + dx, y: panStartRef.current.y + dy });
  };

  const handleMouseUp = () => {
    draggingRef.current = false;
  };

  // Touch: pinch & pan (only for images)
  const handleTouchStart = (e) => {
    if (isPdf) return; // Don't handle touch for PDFs

    if (e.touches.length === 2) {
      // prevent browser pinch-zoom / modal zoom
      e.preventDefault();
      const d = getTouchDistance(e.touches[0], e.touches[1]);
      const c = getTouchCenter(e.touches[0], e.touches[1]);
      lastTouchDistanceRef.current = d;
      lastTouchCenterRef.current = c;
    } else if (e.touches.length === 1) {
      draggingRef.current = true;
      dragStartRef.current = { x: e.touches[0].clientX, y: e.touches[0].clientY };
      panStartRef.current = { ...pan };
    }
  };

  const handleTouchMove = (e) => {
    if (isPdf) return; // Don't handle touch for PDFs

    if (e.touches.length === 2 && lastTouchDistanceRef.current) {
      e.preventDefault();
      const d = getTouchDistance(e.touches[0], e.touches[1]);
      const c = getTouchCenter(e.touches[0], e.touches[1]);

      const scaleFactor = d / lastTouchDistanceRef.current;
      const desiredZoom = clampZoom(Math.round(zoom * scaleFactor));

      // zoom towards center of pinch
      zoomToPoint(c.x, c.y, desiredZoom);

      lastTouchDistanceRef.current = d;
      lastTouchCenterRef.current = c;
    } else if (e.touches.length === 1 && draggingRef.current) {
      e.preventDefault();
      const dx = e.touches[0].clientX - dragStartRef.current.x;
      const dy = e.touches[0].clientY - dragStartRef.current.y;
      setPan({ x: panStartRef.current.x + dx, y: panStartRef.current.y + dy });
    }
  };

  const handleTouchEnd = (e) => {
    // reset when no touches remain
    if (!e.touches || e.touches.length === 0) {
      lastTouchDistanceRef.current = null;
      lastTouchCenterRef.current = null;
      draggingRef.current = false;
    }
  };

  // Buttons (only for images)
  const zoomIn = () => {
    if (isPdf) return;
    const newZoom = clampZoom(zoom + 20);
    const rect = containerRef.current.getBoundingClientRect();
    zoomToPoint(rect.left + rect.width / 2, rect.top + rect.height / 2, newZoom);
  };

  const zoomOut = () => {
    if (isPdf) return;
    const newZoom = clampZoom(zoom - 20);
    const rect = containerRef.current.getBoundingClientRect();
    zoomToPoint(rect.left + rect.width / 2, rect.top + rect.height / 2, newZoom);
  };

  const rotate = () => {
    if (isPdf) return;
    setRotation((r) => (r + 90) % 360);
  };

  const reset = () => {
    if (isPdf) return;
    setZoom(100);
    setPan({ x: 0, y: 0 });
    setRotation(0);
  };

  const download = () => {
    if (!billUrl) return;
    window.open(billUrl, "_blank");
  };

  return (
    <div className="flex flex-col h-full w-full select-none">
      <style>{`
        .pdf-control-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 0.25rem 0.5rem;
          font-size: 0.75rem;
          font-weight: 500;
          border-radius: 5px;
          border: 1px solid #e5e7eb;
          background: #ffffff;
          color: #374151;
          cursor: pointer;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
        }
        .pdf-control-btn:hover:not(:disabled) {
          background: #f9fafb;
          border-color: #d1d5db;
          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
        }
        .pdf-control-btn:active:not(:disabled) {
          background: #f3f4f6;
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
        }
        .pdf-control-btn:disabled {
          opacity: 0.4;
          cursor: not-allowed;
          background: #f9fafb;
        }
      `}</style>
      {/* Controls - only show zoom/rotate for images */}
      {isImage && (
        <div className="flex items-center  gap-1 md:gap-2 mb-[6px] p-[6px] bg-white rounded-md shadow-sm">
          {isImage && btnAllowed.includes("zoomIn") && (
            <button onClick={zoomIn} className="pdf-control-btn">
              Zoom +
            </button>
          )}
          {isImage && btnAllowed.includes("zoomOut") && (
            <button onClick={zoomOut} className="pdf-control-btn">
              Zoom -
            </button>
          )}
          {isImage && btnAllowed.includes("rotate") && (
            <button onClick={rotate} className="pdf-control-btn">
              Rotate
            </button>
          )}
          {isImage && btnAllowed.includes("reset") && (
            <button onClick={reset} className="pdf-control-btn">
              Reset
            </button>
          )}
          {isImage && btnAllowed.includes("open") && (
            <button onClick={download} className="pdf-control-btn" disabled={!billUrl}>
              Open
            </button>
          )}
        </div>
      )}

      {/* PDF Controls - Open in New Tab */}
      {/* {isPdf && btnAllowed.includes("open") && (
        <div className="flex items-center gap-2 mb-[6px] p-[6px] bg-white rounded-md shadow-sm">
          <button onClick={download} className="pdf-control-btn" disabled={!billUrl}>
            Open PDF in New Tab
          </button>
        </div>
      )} */}

      {/* Viewer */}
      <div
        ref={containerRef}
        className="pdf-viewer-wrapper relative flex-1 bg-gray-50 overflow-hidden rounded w-full"
        onWheel={handleWheel}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          touchAction: isPdf ? "auto" : "none",
          overscrollBehavior: "contain",
        }}
      >
        {/* Show PDF - Use data URL for blob PDFs (better compatibility), iframe for regular URLs */}
        {isPdf && !pdfLoadError && (
          <>
            {pdfDataUrl ? (
              // Use data URL for blob PDFs - better browser compatibility
              <iframe
                src={pdfDataUrl}
                title="PDF Viewer"
                style={{
                  width: "100%",
                  height: "100%",
                  border: "none",
                  display: "block",
                }}
              />
            ) : (
              // Use original URL for regular PDF URLs
              <iframe
                src={billUrl}
                title="PDF Viewer"
                style={{
                  width: "100%",
                  height: "100%",
                  border: "none",
                  display: "block",
                }}
                onError={(e) => {
                  console.error("PDF iframe failed to load:", e);
                  setPdfLoadError(true);
                }}
              />
            )}
          </>
        )}

        {/* PDF Load Error - Show fallback with object tag */}
        {isPdf && pdfLoadError && (
          <div className="w-full h-full flex flex-col">
            <object
              data={pdfDataUrl || billUrl}
              type="application/pdf"
              style={{
                width: "100%",
                height: "100%",
                border: "none",
              }}
            >
              <embed
                src={pdfDataUrl || billUrl}
                type="application/pdf"
                style={{
                  width: "100%",
                  height: "100%",
                  border: "none",
                }}
              />
              <div className="flex flex-col items-center justify-center gap-4 p-8 h-full">
                <div className="text-gray-600 text-center">
                  <p className="text-lg font-semibold mb-2">Unable to display PDF in browser</p>
                  <p className="text-sm text-gray-500">
                    Your browser may not support inline PDF viewing.
                  </p>
                </div>
                <button
                  onClick={() => window.open(pdfDataUrl || billUrl, "_blank")}
                  className="pdf-control-btn px-6 py-2 text-base"
                  style={{ fontSize: "14px" }}
                >
                  Open PDF in New Tab
                </button>
              </div>
            </object>
          </div>
        )}

        {/* Show image with zoom/pan/rotate controls */}
        {isImage && (
          <div
            style={{
              transform: `translate(${pan.x}px, ${pan.y}px)`,
              transformOrigin: "center center",
              transition: draggingRef.current ? "none" : "transform 0.06s linear",
              willChange: "transform",
              display: "inline-block",
            }}
          >
            <img
              ref={imageRef}
              src={billUrl}
              alt="Document"
              style={{
                display: "block",
                transform: `scale(${zoom / 100}) rotate(${rotation}deg)`,
                transformOrigin: "center center",
                maxWidth: "100%",
                maxHeight: "100%",
                userSelect: "none",
                WebkitUserDrag: "none",
              }}
            />
          </div>
        )}

        {/* Show fallback message when no image or PDF is available */}
        {!isImage && !isPdf && (
          <div className="flex flex-col items-center justify-center gap-3 p-8 h-full text-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-16 w-16 text-gray-300"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={1}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
            <p className="text-gray-500 text-sm font-medium">Image or PDF not available</p>
          </div>
        )}
      </div>
    </div>
  );
};
